'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Api = exports.ApiReference = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _dec54, _dec55, _dec56, _dec57, _dec58, _dec59, _dec60, _desc, _value, _class;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.createApiDataSource = createApiDataSource;
exports.createApiGroupData = createApiGroupData;
exports.createApiFilterData = createApiFilterData;
exports.createServerCollection = createServerCollection;
exports.updateServerCollection = updateServerCollection;
exports.considerValid = considerValid;
exports.validateCollection = validateCollection;
exports.validateItem = validateItem;
exports.createDraftRecord = createDraftRecord;
exports.mergeDraftRecord = mergeDraftRecord;
exports.createDraftRelationshipsRecord = createDraftRelationshipsRecord;
exports.mergeDraftRelationshipsRecord = mergeDraftRelationshipsRecord;
exports.createServerRecord = createServerRecord;
exports.mergeServerRecord = mergeServerRecord;
exports.createCombinedRecord = createCombinedRecord;
exports.createServerItem = createServerItem;
exports.createDraftItem = createDraftItem;
exports.combineItemDraftAndServer = combineItemDraftAndServer;
exports.updateDraftItem = updateDraftItem;
exports.requestSaveItem = requestSaveItem;
exports.receiveSaveItem = receiveSaveItem;
exports.receiveSaveItemRemove = receiveSaveItemRemove;
exports.updateServerItem = updateServerItem;
exports.removeDraftItem = removeDraftItem;
exports.restoreDraftItem = restoreDraftItem;
exports.cleanupDataSources = cleanupDataSources;
exports.cleanupGroups = cleanupGroups;
exports.cleanupFilters = cleanupFilters;

var _deepObjectDiff = require('deep-object-diff');

var _immutable = require('immutable');

var _amsLoaderUtils = require('@artsman/ams-loader-utils');

var _reselect = require('reselect');

var _constants = require('./constants');

var _models = require('./models');

var _utils = require('./utils');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * Create a new createApiDataSource instance for a given dataSource
 */
function createApiDataSource(dataSource, dataSourceDeclaration) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$groups = options.groups,
      groups = _options$groups === undefined ? undefined : _options$groups;


  return new _models.ApiDataSource({
    dataSource: dataSource,
    dataSourceType: dataSourceDeclaration['type'],
    groups: groups
  });
}

/*
 * Create a new ApiGroupData instance based attached to a given model
 */
function createApiGroupData() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$filters = options.filters,
      filters = _options$filters === undefined ? undefined : _options$filters;


  return new _models.ApiGroupData({
    filters: filters,
    model: null,
    modelName: "",
    loading: true,
    loadingUnauthorized: false,
    loadingError: null
  });
}

/*
 * Create a new ApiFilterData instance based attached to a given model
 */
function createApiFilterData() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var query = options.query,
      _options$sort = options.sort,
      sort = _options$sort === undefined ? undefined : _options$sort,
      _options$only = options.only,
      only = _options$only === undefined ? undefined : _options$only,
      _options$limit = options.limit,
      limit = _options$limit === undefined ? undefined : _options$limit,
      _options$subscribers = options.subscribers,
      subscribers = _options$subscribers === undefined ? (0, _immutable.Set)() : _options$subscribers,
      _options$model = options.model,
      model = _options$model === undefined ? null : _options$model,
      _options$loading = options.loading,
      loading = _options$loading === undefined ? true : _options$loading,
      _options$loadingUnaut = options.loadingUnauthorized,
      loadingUnauthorized = _options$loadingUnaut === undefined ? false : _options$loadingUnaut,
      _options$loadingError = options.loadingError,
      loadingError = _options$loadingError === undefined ? null : _options$loadingError,
      _options$lruSequence = options.lruSequence,
      lruSequence = _options$lruSequence === undefined ? undefined : _options$lruSequence,
      _options$lastRequestT = options.lastRequestTimestamp,
      lastRequestTimestamp = _options$lastRequestT === undefined ? undefined : _options$lastRequestT;


  var modelName = "";
  if (model !== null) {
    modelName = model.modelName;
  }

  // Ensure that sort is always a List (if it's not a string)
  if (_immutable.Set.isSet(sort) || Array.isArray(sort)) {
    sort = (0, _immutable.List)(sort);
  }

  // Ensure that only is always a Set (if it's not a string)
  if (_immutable.List.isList(only) || Array.isArray(only)) {
    only = (0, _immutable.Set)(only);
  }

  return new _models.ApiFilterData({
    query: query,
    sort: sort,
    limit: limit,
    only: only,
    payload: undefined,
    meta: new _models.ApiMeta({
      hasInitialData: false,
      itemCount: 0,
      loading: loading,
      loadingUnauthorized: loadingUnauthorized,
      loadingError: loadingError,
      model: model,
      modelName: modelName,
      needsUpdate: false,
      lastInsertKey: 0,
      lruSequence: lruSequence,
      lastRequestTimestamp: lastRequestTimestamp
    }),
    subscribers: subscribers
  });
}

/*
 * Create a new collection with data received from the server
 */
function createServerCollection(model) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var only = options.only,
      ordered = options.ordered,
      reference = options.reference;


  if (data === undefined) {
    data = [];
  }

  var newData = (0, _immutable.Map)();
  var uniqueKey = void 0;
  var order = undefined;

  if (ordered) {
    order = 0;
  }

  newData = newData.withMutations(function (map) {
    data.forEach(function (item) {
      uniqueKey = model.getUniqueKey(item);
      map.set(uniqueKey, createServerItem(model, uniqueKey, item, { only: only, order: order, reference: reference }));
      if (ordered) {
        order += 1;
      }
    });
  });

  return new model.CollectionClass({ items: newData });
}

/*
 * Update an existing collection with new data received from the server
 */
function updateServerCollection(model) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (data === undefined) {
    // EARLY EXIT: No data means nothing is going to happen
    return function (collection) {
      return collection;
    };
  }

  var only = options.only,
      ordered = options.ordered,
      reference = options.reference;


  return function (collection) {
    var items = collection.get('items');
    if (items === undefined) {
      // Catch edge case where items may not exist yet (shouldn't happen)
      collection = createServerCollection(model, { only: only, ordered: ordered, reference: reference });
      items = collection.get('items');
    }

    // Merge the new server items into the existing items
    // First determine all keys in this new set of data so we can determine collection status
    var currentKeys = (0, _immutable.Set)(data.map(function (item) {
      return model.getUniqueKey(item);
    }));
    var removed = items.filter(function (item, key) {
      return !currentKeys.has(key);
    });

    // Merge any existing records together
    var merged = items.withMutations(function (map) {
      var current = void 0;
      var order = undefined;

      if (ordered) {
        order = 0;
      }

      var uniqueKey = void 0;

      // Add/update from data
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          uniqueKey = model.getUniqueKey(item);

          // Merge the new values into the current items values
          current = map.get(uniqueKey);
          if (current === undefined) {
            map.set(uniqueKey, createServerItem(model, uniqueKey, item, { only: only, order: order, reference: reference }));
          } else {
            map.set(uniqueKey, current.withMutations(updateServerItem(model, item, { only: only, order: order, reference: reference })));
          }

          if (ordered) {
            order += 1;
          }
        }

        // Remove any keys that no longer exist in the data
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      removed.forEach(function (item) {
        uniqueKey = item.uniqueKey;
        if (item._draft !== undefined) {
          // Has draft changes.  Keep the item, but mark as removed.
          map.set(uniqueKey, item.set('_draftRemoval', true));
        } else {
          // Doesn't have draft changes.  Just remove.
          map.delete(uniqueKey);
        }
      });

      return map;
    });

    collection = collection.set('items', merged);
    return collection;
  };
}

/*
 * Function for determining if a set of invalid items should be considered valid for use in
 * `lastValid`
 */
function considerValid(invalid) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var only = options.only;

  if (only !== undefined && invalid !== undefined) {
    var invalidSet = invalid.keySeq().toSet();
    var onlySet = (0, _immutable.Set)(only);
    var difference = invalidSet.intersect(onlySet);
    return difference.size === 0;
  } else {
    return invalid === undefined ? true : invalid.size === 0;
  }
}

/*
 * Validate a collection with the given model and options
 */
function validateCollection(model) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (collection) {
    var items = collection.get('items');
    var keys = items.keys();

    var newItems = items.withMutations(function (map) {
      var item = void 0;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;

          item = map.get(key);
          map.set(key, item.withMutations(validateItem(model, options)));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return map;
    });

    return collection.set('items', newItems);
  };
}

/*
 * Validate an item with the given model and options
 */
function validateItem(model) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$only2 = options.only,
      only = _options$only2 === undefined ? undefined : _options$only2,
      reference = options.reference;


  return function (item) {
    // Re-validate
    var _model$validateData = model.validateData(item.get('_combined'), { reference: reference }),
        valid = _model$validateData.valid,
        invalid = _model$validateData.invalid,
        validatedCombined = _model$validateData.data;

    item.set('_combined', validatedCombined);

    // Update the draft invalid information
    item.set('_invalid', createInvalidMap(valid, invalid, item.get('_invalid')));

    // If the record is valid, then the combined last valid and draft last valid can also be set
    if (considerValid(invalid, { only: only })) {
      item.set('_lastValid', validatedCombined);
    }

    return item;
  };
}

/*
 * Create a new draft Record for an item
 */
function createDraftRecord(model, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var item = options.item,
      reference = options.reference;

  data = model.toImmutable(data, { item: item, reference: reference });
  data = model.setInsertValues(data, { item: item, reference: reference });
  return model.formatData(data, { item: item, reference: reference });
}

/*
 * Merge new changes into existing draft Record for an item
 */
function mergeDraftRecord(current, model, data, item) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var reference = options.reference;

  data = model.toImmutable(data, { item: item, reference: reference });
  data = model.formatData(data, { item: item, reference: reference });
  return current.withMutations((0, _amsLoaderUtils.mergeMatchingKeys)(data));
}

/*
 * Create a new draft Record for an item
 */
function createDraftRelationshipsRecord(model, relationshipData) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var item = options.item,
      reference = options.reference;

  relationshipData = model.toImmutableRelationships(relationshipData, { item: item, reference: reference });
  relationshipData = model.formatRelationships(relationshipData, { item: item, reference: reference });
  return model.setInsertRelationships(relationshipData, { reference: reference });
}

/*
 * Merge new changes into existing draft relationships Record
 */
function mergeDraftRelationshipsRecord(current, model, relationshipData) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var item = options.item,
      reference = options.reference;

  relationshipData = model.toImmutableRelationships(relationshipData, { item: item, reference: reference });
  relationshipData = model.formatRelationships(relationshipData, { item: item, reference: reference });
  return current.withMutations((0, _amsLoaderUtils.mergeMatchingKeys)(relationshipData));
}

/*
 * Create a new typed server Record for an item
 */
function createServerRecord(model, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var item = options.item,
      reference = options.reference;


  data = model.toImmutable(data, { createContainers: true, item: item, reference: reference });
  return model.formatData(data, { item: item, reference: reference });
}

/*
 * Merge new changes into existing server Record for an item
 */
function mergeServerRecord(current, model, data) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var item = options.item,
      reference = options.reference;


  data = model.toImmutable(data, { item: item, reference: reference });
  data = model.formatData(data, { item: item, reference: reference });
  return current.withMutations((0, _amsLoaderUtils.mergeMatchingKeys)(data));
}

/*
 * Create a new combined Record for an item
 */
function createCombinedRecord(model, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var item = options.item,
      reference = options.reference;


  data = model.toImmutable(data, { createContainers: true, item: item, reference: reference });
  return model.formatData(data, { item: item, reference: reference });
}

/*
 * Create a new model instance for server data for an item
 */
function createServerItem(model, id, data) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$only3 = options.only,
      only = _options$only3 === undefined ? undefined : _options$only3,
      _options$order = options.order,
      order = _options$order === undefined ? undefined : _options$order,
      reference = options.reference,
      _options$temporary = options.temporary,
      temporary = _options$temporary === undefined ? false : _options$temporary;


  var combined = void 0,
      lastValid = void 0,
      server = void 0,
      invalid = void 0,
      validation = void 0;

  if (data === undefined) {
    data = {};
  }

  server = createServerRecord(model, data, { reference: reference });
  combined = createCombinedRecord(model, data, { reference: reference });
  validation = model.validateData(combined, { reference: reference });
  combined = validation.data;
  invalid = createInvalidMap(validation.valid, validation.invalid);

  if (considerValid(validation.invalid, { only: only })) {
    lastValid = combined;
  } else {
    lastValid = model.setInitialValidValues(validation, { reference: reference });
  }

  return new model({
    _combined: combined,
    _lastValid: lastValid,
    _invalid: invalid,

    _draft: undefined,
    _draftCreation: false,
    _draftRemoval: false,

    _draftRelationships: undefined,
    _draftRelationshipsInvalid: undefined,

    _interfaceID: id === _constants.STANDALONE_ITEM ? 1 : id,
    _storeID: id,

    _order: order,

    _server: server,
    _serverRemoved: false,
    _serverTemporary: temporary,

    _saving: false,
    _saveError: undefined
  });
}

/*
 * Create a new model instance for a new draft for an item
 */
function createDraftItem(model, id) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$only4 = options.only,
      only = _options$only4 === undefined ? undefined : _options$only4,
      reference = options.reference;


  var combined = void 0,
      draft = void 0,
      invalid = void 0,
      lastValid = void 0,
      validation = void 0,
      relationships = void 0,
      relationshipsValidation = void 0,
      relationshipsInvalid = void 0;

  if (data === undefined) {
    data = {};
  }

  var _model$splitChanges = model.splitChanges(data),
      _model$splitChanges2 = _slicedToArray(_model$splitChanges, 2),
      dataChanges = _model$splitChanges2[0],
      relationshipChanges = _model$splitChanges2[1];

  draft = createDraftRecord(model, dataChanges, { reference: reference });
  combined = createCombinedRecord(model, dataChanges, { reference: reference });
  validation = model.validateData(combined, { reference: reference });
  combined = validation.data;

  invalid = createInvalidMap(validation.valid, validation.invalid);

  if (considerValid(validation.invalid, { only: only })) {
    lastValid = combined;
  } else {
    lastValid = model.setInitialValidValues(validation, { reference: reference });
  }

  // Check relationships
  relationships = createDraftRelationshipsRecord(model, relationshipChanges, { reference: reference });
  relationshipsValidation = model.validateRelationships(relationships, { reference: reference });
  relationships = relationshipsValidation.relationships;
  relationshipsInvalid = createInvalidMap(relationshipsValidation.valid, relationshipsValidation.invalid);

  return new model({
    _combined: combined,
    _lastValid: lastValid,
    _invalid: invalid,

    _draft: draft,
    _draftCreation: true,
    _draftRemoval: false,

    _draftRelationships: relationships,
    _draftRelationshipsInvalid: relationshipsInvalid,

    _interfaceID: id,
    _storeID: id,

    _order: -1,

    _server: undefined,
    _serverRemoved: false,

    _saving: false,
    _saveError: undefined
  });
}

// Need to allow empty string, false etc for values. So we need to use isDefined(value) instead of !!value
function isDefined(value) {
  return value !== undefined;
}

/*
 * Merge draft and server to create a single combined record.
 */
function combineItemDraftAndServer(attributes, draft, server) {
  return function (combined) {
    if (draft === undefined && server === undefined) {
      return undefined;
    }

    var currentDraftValue = void 0,
        currentServerValue = void 0;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = attributes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var attribute = _step3.value;

        if (server !== undefined && (draft === undefined || draft.get(attribute) === undefined)) {
          // Have server data, but not draft data
          combined.set(attribute, server.get(attribute));
        } else if (draft !== undefined && (server === undefined || server.get(attribute) === undefined)) {
          // Have draft data, but not server data
          combined.set(attribute, draft.get(attribute));
        } else {
          // Have both draft and server data
          currentDraftValue = draft.get(attribute);
          currentServerValue = server.get(attribute);

          var newCombined = void 0;
          if (isDefined(currentDraftValue)) {
            newCombined = currentDraftValue;
          } else if (isDefined(currentServerValue)) {
            newCombined = currentServerValue;
          } else {
            throw new Error("No server or draft when combining items.");
          }
          combined.set(attribute, newCombined);
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return combined;
  };
}

/*
 * Update the combined state of an item
 */
function _createCombinedRecord(model, server, draft, combined, item) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var reference = options.reference;


  if (draft === undefined && server === undefined) {
    // No draft data or server data
    combined = undefined;
  } else if (draft === undefined && server !== undefined) {
    // Server data only, just use that.
    if (combined === undefined) {
      combined = createCombinedRecord(model, server, item, { reference: reference });
    } else {
      combined = combined.withMutations((0, _amsLoaderUtils.mergeMatchingKeys)(server));
    }
  } else if (draft !== undefined && server === undefined) {
    // Draft data only, just use that.
    if (combined === undefined) {
      combined = createCombinedRecord(model, draft, item, { reference: reference });
    } else {
      combined = combined.withMutations((0, _amsLoaderUtils.mergeMatchingKeys)(draft));
    }
  } else if (draft !== undefined && server !== undefined) {
    // Both draft and server data
    if (combined === undefined) {
      combined = createCombinedRecord(model, server, item, { reference: reference });
    }
    combined = combined.withMutations(combineItemDraftAndServer(model.schema.keys, draft, server));
  } else {
    throw 'Unknown item state when combining draft and server: ' + item;
  }
  return combined;
}

/*
 * Create the draft invalid state of an item (a common storage area for errors on the item)
 */
function createInvalidMap(valid, invalid, previous) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var only = options.only;

  // Set the invalid datum markers (if there are any)

  var draftInvalid = void 0;
  if (invalid !== undefined && !invalid.isEmpty()) {
    if (previous !== undefined) {
      draftInvalid = previous = previous.withMutations((0, _amsLoaderUtils.mergeChangedKeys)(invalid));
    } else {
      draftInvalid = invalid;
    }
  }
  if (previous !== undefined && valid !== undefined && !valid.isEmpty()) {
    draftInvalid = previous.withMutations(function (map) {
      valid.forEach(function (key) {
        map.delete(key);
      });
    });
    if (draftInvalid.isEmpty()) {
      draftInvalid = undefined;
    }
  }

  return draftInvalid;
}

/*
 * Update the draft state with new changes
 */
function updateDraftItem(model, changes) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$only5 = options.only,
      only = _options$only5 === undefined ? undefined : _options$only5,
      reference = options.reference;


  return function (item) {
    var _model$splitChanges3 = model.splitChanges(changes),
        _model$splitChanges4 = _slicedToArray(_model$splitChanges3, 2),
        dataChanges = _model$splitChanges4[0],
        relationshipChanges = _model$splitChanges4[1];

    // Set draft data (including best-effort formatting)


    var newDraft = void 0;
    var draft = item.get('_draft');
    if (draft === undefined) {
      newDraft = createDraftRecord(model, dataChanges, { item: item, reference: reference });
    } else {
      newDraft = mergeDraftRecord(draft, model, dataChanges, item, { reference: reference });
    }
    item.set('_draft', newDraft);

    // If there are draft relationships then update those too (including best-effort formatting)
    if (!(0, _utils.isMapEmpty)(relationshipChanges)) {
      var newDraftRelationships = void 0;
      var draftRelationships = item.get('_draftRelationships');
      if (draftRelationships === undefined) {
        newDraftRelationships = createDraftRelationshipsRecord(model, relationshipChanges, { item: item, reference: reference });
      } else {
        newDraftRelationships = mergeDraftRelationshipsRecord(draftRelationships, model, relationshipChanges, { item: item, reference: reference });
      }

      var _model$validateRelati = model.validateRelationships(newDraftRelationships, { reference: reference }),
          relatedValid = _model$validateRelati.valid,
          relatedInvalid = _model$validateRelati.invalid,
          relatedValidated = _model$validateRelati.relationships;

      // Update the invalid relationship information


      item.set('_draftRelationships', relatedValidated);
      item.set('_draftRelationshipsInvalid', createInvalidMap(relatedValid, relatedInvalid, relatedValidated));
    }

    // Update the combined item, and validate the combined item
    var newCombined = _createCombinedRecord(model, item.get('_server'), newDraft, item.get('_combined'), { reference: reference });

    var _model$validateData2 = model.validateData(newCombined, { reference: reference }),
        valid = _model$validateData2.valid,
        invalid = _model$validateData2.invalid,
        validatedCombined = _model$validateData2.data;

    item.set('_combined', validatedCombined);

    var newInvalid = createInvalidMap(valid, invalid, item.get('_invalid'));
    // Update the invalid information
    item.set('_invalid', newInvalid);

    // If the record is valid, then the combined last valid and draft last valid can also be set
    if (invalid.size == 0) {
      item.set('_lastValid', validatedCombined);
    }

    return item;
  };
}

/*
 * Mark an individual item with its saving status.
 */
function requestSaveItem() {
  return function (item) {
    item.set('_saving', true);
    return item;
  };
}

/*
 * A save was successful.  Revert all the draft keys that were supposed to be saved (server and draft should match now)
 */
function receiveSaveItem(action, model, id, changes, response) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var reference = options.reference;


  return function (item) {
    return item.withMutations(function (itemState) {
      // TODO: Check sequence of loaded items and see if its later than when the request was sent.  If so, then only
      // TODO: a revert needs to be done.  Otherwise we can merge the draft into the server for temporary user
      // TODO: coherence.
      if (action === _constants.WRITE_STYLE.CREATE || action === _constants.WRITE_STYLE.UPDATE) {
        if (changes !== undefined) {
          // Merge the user changes into the server items including the new id
          var updatedData = changes.toJS();
          if (id !== _constants.STANDALONE_ITEM) {
            updatedData[model.uniqueKey] = id;
          }
          try {
            itemState = updateServerItem(model, updatedData, { reference: reference })(itemState);
          } catch (TypeError) {}
          // If we can't coerece it into a server item then we have to wait for the server to give the record back.


          // Revert the changed keys (they are now in server)
          itemState = revertDraftItem(model, Array.from(changes.keys()), { reference: reference })(itemState);
        }
      } else if (action === _constants.WRITE_STYLE.DELETE) {
        throw new Error("Can't use receiveSaveItem with delete.  See receiveSaveItemRemove.");
      }

      // Update the saving state
      itemState.set('_saving', false);
      itemState.set('_saveError', undefined);
      return itemState;
    });
  };
}

/*
 * A save was successful for a removal.  Clear any save error and rotate the draft removal into a save removal
 */
function receiveSaveItemRemove(id) {
  if (id === undefined) {
    // EARLY EXIT: No id means nothing is going to happen
    return function (collection) {
      return collection;
    };
  }

  if (id === _constants.STANDALONE_ITEM) {
    // EARLY EXIT: Clearing a standlone item just sets it to undefined
    return function (item) {
      return undefined;
    };
  }

  return function (collection) {
    var item = collection.getIn(['items', id]);
    if (item === undefined) {
      // EARLY EXIT: No item yet?  Nothing will happen
      return collection;
    }

    // Remove the item at the given ID
    return collection.deleteIn(['items', id]);
  };
}

/*
 * Receive an error from the saving of the draft.
 */
function receiveSaveItemError(error) {
  return function (item) {
    item.set('_saving', false);
    item.set('_saveError', error);
    return item;
  };
}

/*
 * Determine if a draft is populated with all undefined entries.
 */
function _isDraftEmpty(model, draft) {
  if (draft === undefined) {
    // EARLY EXIT: Draft is already undefined, so that means empty.
    return true;
  }

  // Loop all the data in the item and short circuit if one defined attribute is found.
  var isEmpty = true;
  model.schema.keys.some(function (key) {
    if (draft.get(key) !== undefined) {
      isEmpty = false;
      return true;
    }
    return false;
  });
  return isEmpty;
}

/*
 * Determine if a draft is populated with all undefined entries.
 */
function _areDraftRelationshipsEmpty(model, draftRelationships) {
  if (draftRelationships === undefined) {
    // EARLY EXIT: Draft is already undefined, so that means empty.
    return true;
  }

  // Loop all the data in the item and short circuit if one defined attribute is found.
  var isEmpty = true;
  model.relationshipSchema.keys.some(function (key) {
    if (draftRelationships.get(key) !== undefined) {
      isEmpty = false;
      return true;
    }
    return false;
  });
  return isEmpty;
}

/*
 * Revert certain keys from a draft for an item
 */
function revertDraftItem(model, keys) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$only6 = options.only,
      only = _options$only6 === undefined ? undefined : _options$only6,
      reference = options.reference;


  return function (item) {
    var newDraft = void 0;
    var draft = item.get('_draft');
    if (draft !== undefined) {
      if (keys === _constants.REVERT_ALL) {
        newDraft = undefined;
      } else {
        newDraft = draft.withMutations((0, _amsLoaderUtils.clearMatchingKeys)(keys));
        if (_isDraftEmpty(model, newDraft)) {
          newDraft = undefined;
        }
      }
      item.set('_draft', newDraft);

      var newCombined = _createCombinedRecord(model, item.get('_server'), newDraft, item.get('_combined'), { reference: reference });
      if (newCombined !== undefined) {
        var _model$validateData3 = model.validateData(newCombined, { reference: reference }),
            valid = _model$validateData3.valid,
            invalid = _model$validateData3.invalid,
            validatedCombined = _model$validateData3.data;

        item.set('_combined', validatedCombined);

        // Update the draft invalid information
        item.set('_invalid', createInvalidMap(valid, invalid, item.get('_invalid')));

        // If the record is valid, then the combined last valid and draft last valid can also be set
        if (considerValid(item.get('_invalid'), { only: only })) {
          item.set('_lastValid', validatedCombined);
        }
      } else {
        item.set('_combined', newCombined);
      }
    }

    var newDraftRelationships = void 0;
    var draftRelationships = item.get('_draftRelationships');
    if (draftRelationships !== undefined) {
      if (keys === _constants.REVERT_ALL) {
        item.set('_draftRelationships', undefined);
        item.set('_draftRelationshipsInvalid', undefined);
      } else {
        newDraftRelationships = draftRelationships.withMutations((0, _amsLoaderUtils.clearMatchingKeys)(keys));
        if (_areDraftRelationshipsEmpty(model, newDraftRelationships)) {
          newDraftRelationships = undefined;
        }

        var _model$validateRelati2 = model.validateRelationships(newDraftRelationships, { reference: reference }),
            relatedValid = _model$validateRelati2.valid,
            relatedInvalid = _model$validateRelati2.invalid,
            relatedValidated = _model$validateRelati2.relationships;

        // Update the invalid relationship information


        item.set('_draftRelationships', relatedValidated);
        item.set('_draftRelationshipsInvalid', createInvalidMap(relatedValid, relatedInvalid, relatedValidated));
      }
    }

    // Clear any draft removed flags
    item.set('_draftRemoval', false);

    // Clear any save errors (gives user the ability to get rid of an error message)
    item.set('_saveError', undefined);
    return item;
  };
}

/*
 * Update the server state for an item
 */
function updateServerItem(model, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$only7 = options.only,
      only = _options$only7 === undefined ? undefined : _options$only7,
      _options$order2 = options.order,
      order = _options$order2 === undefined ? undefined : _options$order2,
      reference = options.reference;


  return function (item) {
    var newServer = void 0;
    var server = item.get('_server');
    if (server === undefined) {
      newServer = createServerRecord(model, data, { item: item, reference: reference });
    } else {
      newServer = mergeServerRecord(server, model, data, { item: item, reference: reference });
    }
    item.set('_server', newServer);

    if (order !== undefined) {
      item.set('_order', order);
    }

    var newCombined = _createCombinedRecord(model, newServer, item.get('_draft'), item.get('_combined'), item, { reference: reference });

    var _model$validateData4 = model.validateData(newCombined, { reference: reference }),
        valid = _model$validateData4.valid,
        invalid = _model$validateData4.invalid,
        validatedCombined = _model$validateData4.data;

    item.set('_combined', validatedCombined);

    // Update the draft invalid information
    item.set('_invalid', createInvalidMap(valid, invalid, item.get('_invalid')));

    // If the record is valid, then the combined last valid and draft last valid can also be set
    if (considerValid(item.get('_invalid'), { only: only })) {
      item.set('_lastValid', validatedCombined);
    }

    return item;
  };
}

/*
 * Mark an item as having been marked for removal
 */
function removeDraftItem() {
  return function (item) {
    item.set('_draftRemoval', true);
    return item;
  };
}

/*
 * Undo the mark that an item is slated for removal
 */
function restoreDraftItem() {
  return function (item) {
    item.set('_draftRemoval', false);
    return item;
  };
}

/*
 * Cleanup data sources
 */
function cleanupDataSources(options) {
  return function (dataSourcesState) {
    var newDataSourcesState = dataSourcesState;
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = dataSourcesState[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var _step4$value = _slicedToArray(_step4.value, 2),
            key = _step4$value[0],
            dataSource = _step4$value[1];

        if (dataSource.groups['isEmpty'] === undefined || dataSource.groups.isEmpty()) {
          newDataSourcesState = newDataSourcesState.remove(key);
        } else {
          var newDataSourceState = dataSource.set('groups', dataSource.get('groups').withMutations(cleanupGroups(options)));
          newDataSourcesState = newDataSourcesState.set(key, newDataSourceState);
        }
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    return newDataSourcesState;
  };
}

/*
 * Cleanup groups
 */
function cleanupGroups(options) {
  return function (groupsState) {
    var newGroupsState = groupsState;
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = groupsState[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var _step5$value = _slicedToArray(_step5.value, 2),
            key = _step5$value[0],
            group = _step5$value[1];

        if (group.filters['isEmpty'] === undefined || groups.filters.isEmpty()) {
          newGroupsState = newGroupsState.remove(key);
        } else {
          var newGroupState = group.set('filters', group.get('filters').withMutations(cleanupFilters(options)));
          newGroupsState = newGroupsState.set(key, newGroupState);
        }
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    return newGroupsState;
  };
}

/*
 * Cleanup filters
 */
function cleanupFilters(options) {
  var _options$lruCutoff = options.lruCutoff,
      lruCutoff = _options$lruCutoff === undefined ? undefined : _options$lruCutoff,
      _options$timestampCut = options.timestampCutoff,
      timestampCutoff = _options$timestampCut === undefined ? undefined : _options$timestampCut;


  return function (filtersState) {
    var newFiltersState = filtersState;
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = filtersState[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var _step6$value = _slicedToArray(_step6.value, 2),
            key = _step6$value[0],
            filter = _step6$value[1];

        if (filter.subscribers['isEmpty'] === undefined || filter.subscribers.isEmpty()) {
          if (lruCutoff !== undefined && filter.meta.lruSequence !== undefined && filter.meta.lruSequence < lruCutoff) {
            newFiltersState = newFiltersState.remove(key);
          } else if (timestampCutoff !== undefined && filter.meta.lastRequestTimestamp !== undefined && filter.meta.lastRequestTimestamp < timestampCutoff) {
            newFiltersState = newFiltersState.remove(key);
          }
        }
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    return newFiltersState;
  };
}

/*
 * When cross-referencing reads are required then this object is used as a proxy to lazy load reads
 * from a bound Api (reducer) instance and a current state.
 *
 * constructor
 * @param {string} reducer - instance of Api in use
 * @param {object} getState - callback for getting the current state
 */

var ApiReference = exports.ApiReference = function () {
  function ApiReference(reducer, getState) {
    _classCallCheck(this, ApiReference);

    this._reducer = reducer;
    this._getState = getState;
  }

  _createClass(ApiReference, [{
    key: 'read',
    value: function read(dataSource, group, alias) {
      var state = this._getState();
      return this._reducer.readInternal(state, dataSource, group, alias);
    }
  }, {
    key: 'meta',
    value: function meta(dataSource, group, alias) {
      var state = this._getState();
      return this._reducer.metaInternal(state, dataSource, group, alias);
    }
  }, {
    key: 'authentication',
    value: function authentication() {
      var state = this._getState();
      return this._reducer.authenticationInternal(state);
    }
  }]);

  return ApiReference;
}();

/*
 * Main Api data loader.  Given a stateKey and mapping of dataSources this class will manage data in a redux store.
 *
 Example data sources:
 *
 *  dataSources = Map({
 *     balancers: { type: DATA_SOURCE_TYPE.COLLECTION },
 *     default_domain: { type: DATA_SOURCE_TYPE.ITEM },
 *  })
 *
 * @constructor
 * @param {string} stateKey - string 'key' to use as the location to store all data in a redux store
 * @param {object} dataSources - mapping of data sources being used, the model they are associated with, and whether or not they are a collection.
 * @param {function} moduleLoader - callback for loading a model's module
 * @param {function} dataReader - callback for reading data for a data source
 * @param {function} dataWriter - callback for writing data to a data source
 * @param {object} options - Additional options for configuring this data loader.
 * @param {object} options.initialState - Initial state for the store
 */


var Api = exports.Api = (_dec = (0, _amsLoaderUtils.action)(_constants.AUTH_LOGIN_SYNC), _dec2 = (0, _amsLoaderUtils.reducer)(_constants.AUTH_LOGIN_SYNC), _dec3 = (0, _amsLoaderUtils.action)(_constants.AUTH_LOGIN_REQUEST), _dec4 = (0, _amsLoaderUtils.reducer)(_constants.AUTH_LOGIN_REQUEST), _dec5 = (0, _amsLoaderUtils.action)(_constants.AUTH_LOGIN_SUCCESS), _dec6 = (0, _amsLoaderUtils.reducer)(_constants.AUTH_LOGIN_SUCCESS), _dec7 = (0, _amsLoaderUtils.action)(_constants.AUTH_LOGIN_ERROR), _dec8 = (0, _amsLoaderUtils.reducer)(_constants.AUTH_LOGIN_ERROR), _dec9 = (0, _amsLoaderUtils.action)(_constants.AUTH_LOGOUT_SYNC), _dec10 = (0, _amsLoaderUtils.reducer)(_constants.AUTH_LOGOUT_SYNC), _dec11 = (0, _amsLoaderUtils.action)(_constants.AUTH_LOGOUT_REQUEST), _dec12 = (0, _amsLoaderUtils.reducer)(_constants.AUTH_LOGOUT_REQUEST), _dec13 = (0, _amsLoaderUtils.action)(_constants.AUTH_LOGOUT_SUCCESS), _dec14 = (0, _amsLoaderUtils.reducer)(_constants.AUTH_LOGOUT_SUCCESS), _dec15 = (0, _amsLoaderUtils.action)(_constants.AUTH_LOGOUT_ERROR), _dec16 = (0, _amsLoaderUtils.reducer)(_constants.AUTH_LOGOUT_ERROR), _dec17 = (0, _amsLoaderUtils.action)(_constants.SUBSCRIBE), _dec18 = (0, _amsLoaderUtils.reducer)(_constants.SUBSCRIBE), _dec19 = (0, _amsLoaderUtils.action)(_constants.UNSUBSCRIBE), _dec20 = (0, _amsLoaderUtils.reducer)(_constants.UNSUBSCRIBE), _dec21 = (0, _amsLoaderUtils.action)(_constants.CLEANUP), _dec22 = (0, _amsLoaderUtils.reducer)(_constants.CLEANUP), _dec23 = (0, _amsLoaderUtils.action)(_constants.SERVER_DATA_AVAILABLE), _dec24 = (0, _amsLoaderUtils.reducer)(_constants.SERVER_DATA_AVAILABLE), _dec25 = (0, _amsLoaderUtils.action)(_constants.REQUEST_MODEL), _dec26 = (0, _amsLoaderUtils.reducer)(_constants.REQUEST_MODEL), _dec27 = (0, _amsLoaderUtils.action)(_constants.RECEIVE_MODEL), _dec28 = (0, _amsLoaderUtils.reducer)(_constants.RECEIVE_MODEL), _dec29 = (0, _amsLoaderUtils.action)(_constants.RECEIVE_MODEL_ERROR), _dec30 = (0, _amsLoaderUtils.reducer)(_constants.RECEIVE_MODEL_ERROR), _dec31 = (0, _amsLoaderUtils.action)(_constants.REQUEST), _dec32 = (0, _amsLoaderUtils.reducer)(_constants.REQUEST), _dec33 = (0, _amsLoaderUtils.action)(_constants.RECEIVE), _dec34 = (0, _amsLoaderUtils.reducer)(_constants.RECEIVE), _dec35 = (0, _amsLoaderUtils.action)(_constants.RECEIVE_ERROR), _dec36 = (0, _amsLoaderUtils.reducer)(_constants.RECEIVE_ERROR), _dec37 = (0, _amsLoaderUtils.action)(_constants.RECEIVE_UNAUTHORIZED), _dec38 = (0, _amsLoaderUtils.reducer)(_constants.RECEIVE_UNAUTHORIZED), _dec39 = (0, _amsLoaderUtils.action)(_constants.RECEIVE_MODEL_UNAUTHORIZED), _dec40 = (0, _amsLoaderUtils.reducer)(_constants.RECEIVE_MODEL_UNAUTHORIZED), _dec41 = (0, _amsLoaderUtils.action)(_constants.ADD_DRAFT), _dec42 = (0, _amsLoaderUtils.reducer)(_constants.ADD_DRAFT), _dec43 = (0, _amsLoaderUtils.action)(_constants.REMOVE_DRAFT), _dec44 = (0, _amsLoaderUtils.reducer)(_constants.REMOVE_DRAFT), _dec45 = (0, _amsLoaderUtils.action)(_constants.RESTORE_DRAFT), _dec46 = (0, _amsLoaderUtils.reducer)(_constants.RESTORE_DRAFT), _dec47 = (0, _amsLoaderUtils.action)(_constants.UPDATE_DRAFT), _dec48 = (0, _amsLoaderUtils.reducer)(_constants.UPDATE_DRAFT), _dec49 = (0, _amsLoaderUtils.action)(_constants.REVERT_DRAFT), _dec50 = (0, _amsLoaderUtils.reducer)(_constants.REVERT_DRAFT), _dec51 = (0, _amsLoaderUtils.action)(_constants.REQUEST_SAVE), _dec52 = (0, _amsLoaderUtils.reducer)(_constants.REQUEST_SAVE), _dec53 = (0, _amsLoaderUtils.action)(_constants.RECEIVE_SAVE), _dec54 = (0, _amsLoaderUtils.reducer)(_constants.RECEIVE_SAVE), _dec55 = (0, _amsLoaderUtils.action)(_constants.RECEIVE_SAVE_ERROR), _dec56 = (0, _amsLoaderUtils.reducer)(_constants.RECEIVE_SAVE_ERROR), _dec57 = (0, _amsLoaderUtils.action)(_constants.RECEIVE_SAVE_UNAUTHORIZED), _dec58 = (0, _amsLoaderUtils.reducer)(_constants.RECEIVE_SAVE_UNAUTHORIZED), _dec59 = (0, _amsLoaderUtils.action)(_constants.ADD_SERVER_TEMPORARY), _dec60 = (0, _amsLoaderUtils.reducer)(_constants.ADD_SERVER_TEMPORARY), (_class = function (_ReduxModule) {
  _inherits(Api, _ReduxModule);

  function Api(stateKey, dataSources, modelLoader, dataReader, dataWriter) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    _classCallCheck(this, Api);

    options['initialState'] = options['initialState'] || new _models.ApiRoot({
      authentication: (0, _models.ApiAuthentication)({ authenticated: false, loading: false, loadingError: null, payload: null }),
      data: (0, _immutable.Map)()
    });

    var _this = _possibleConstructorReturn(this, (Api.__proto__ || Object.getPrototypeOf(Api)).call(this, stateKey, options));

    _this.dataSources = dataSources;
    _this.modelLoader = modelLoader;
    _this.dataReader = dataReader;
    _this.dataWriter = dataWriter;

    _this.auth = options['authenticator'];
    _this.connectSubscriber = options['connectSubscriber'];
    _this.notifier = options['notifier'];
    _this.referenceFactory = options['referenceFactory'];
    _this.disabledFilterSentinel = _constants.DEFAULT_API_FILTER_DISABLED;

    _this._lruSequence = 0;
    return _this;
  }

  /*
   * Internal method for keeping track of the curent LRU sequence.
   */


  _createClass(Api, [{
    key: '_nextLRU',
    value: function _nextLRU() {
      var currentLru = this._lruSequence;
      if (currentLru === _constants.MAX_LRU_SIZE) {
        // Rollaround will end up clearing out a bunch of entries, but since it's such a high number
        // the risk of evicting old entires in rare circumstances should be ok.
        this._lruSequence = 0;
      } else {
        this._lruSequence += 1;
      }
      return currentLru;
    }

    /*
     * Connect a cistp, React decorator to be used when subscribing (a.k.a connecting) to a React component
     */

  }, {
    key: 'setNotifier',
    value: function setNotifier(notifier) {
      this.notifier = notifier;
    }

    /*
     * Build a reference proxy instance so that models can cross reference data in the current state
     */

  }, {
    key: '_buildReferenceProxy',
    value: function _buildReferenceProxy() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var state = options.state,
          getState = options.getState;


      if (state !== undefined && getState !== undefined) {
        throw new Error("Invalid call to _buildReferenceProxy.  Must pass state or getState, but not both.");
      }

      if (state !== undefined) {
        getState = function getState() {
          return state;
        };
      }

      var factory = void 0;
      if (!!this.referenceFactory) {
        factory = this.referenceFactory;
      } else {
        factory = function factory() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return new (Function.prototype.bind.apply(ApiReference, [null].concat(args)))();
        };
      }
      return factory(this, getState);
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_loginSync',
    value: function _loginSync(authenticationPayload) {
      return {
        payload: authenticationPayload
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_loginSyncReducer',
    value: function _loginSyncReducer(state, authenticationPayload) {
      return this._loginSuccessReducer(state, authenticationPayload);
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_loginRequest',
    value: function _loginRequest() {
      return {
        payload: {}
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_loginRequestReducer',
    value: function _loginRequestReducer(state) {
      return state.updateIn(['authentication'], function (authenticationState) {
        return authenticationState.withMutations(function (state) {
          state.set('loading', true);
          state.set('loadingError', null);
        });
      });
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_loginSuccess',
    value: function _loginSuccess(authenticationPayload) {
      return {
        payload: authenticationPayload
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_loginSuccessReducer',
    value: function _loginSuccessReducer(state, authenticationPayload) {
      var newState = state.updateIn(['authentication'], function (authenticationState) {
        return authenticationState.withMutations(function (state) {
          state.set('loading', false);
          state.set('authenticated', true);
          state.set('loadingError', null);
          state.update('payload', function (payload) {
            return payload ? payload.merge(authenticationPayload) : authenticationPayload;
          });
        });
      });
      if (state !== newState && this.notifier) {
        this.notifier.onLogin(authenticationPayload);
      }
      return newState;
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_loginError',
    value: function _loginError(authenticationPayload, error) {
      return {
        payload: error,
        meta: authenticationPayload
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_loginErrorReducer',
    value: function _loginErrorReducer(state, error, authenticationPayload) {
      return state.updateIn(['authentication'], function (authenticationState) {
        return authenticationState.withMutations(function (state) {
          state.set('loading', false);
          state.set('authenticated', false);
          state.set('loadingError', error);
          state.set('payload', authenticationPayload);
        });
      });
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_logoutSync',
    value: function _logoutSync(authenticationPayload) {
      return {
        payload: authenticationPayload
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_logoutSyncReducer',
    value: function _logoutSyncReducer(state, authenticationPayload) {
      return this._logoutSuccessReducer(state, authenticationPayload);
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_logoutRequest',
    value: function _logoutRequest(reason) {
      return {
        payload: reason
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_logoutRequestReducer',
    value: function _logoutRequestReducer(state, reason) {
      return state.updateIn(['authentication'], function (authenticationState) {
        return authenticationState.withMutations(function (state) {
          state.set('loading', true);
          state.set('loadingError', null);
        });
      });
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_logoutSuccess',
    value: function _logoutSuccess(authenticationPayload) {
      return {
        payload: authenticationPayload
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_logoutSuccessReducer',
    value: function _logoutSuccessReducer(state, authenticationPayload) {
      return state.updateIn(['authentication'], function (authenticationState) {
        return authenticationState.withMutations(function (state) {
          state.set('loading', false);
          state.set('authenticated', false);
          state.set('loadingError', null);
          state.set('payload', authenticationPayload);
        });
      });
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_logoutError',
    value: function _logoutError(authenticationPayload, error) {
      return {
        payload: error,
        meta: authenticationPayload
      };
    }

    // TODO, use update instead of withMutations...

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_logoutErrorReducer',
    value: function _logoutErrorReducer(state, error, authenticationPayload) {
      return state.updateIn(['authentication'], function (authenticationState) {
        return authenticationState.withMutations(function (state) {
          state.set('loading', false);
          state.set('authenticated', false);
          state.set('loadingError', error);
          state.set('payload', authenticationPayload);
        });
      });
    }
  }, {
    key: 'checkLogin',
    value: function checkLogin() {
      var _this2 = this;

      return function (dispatch) {
        if (!_this2.auth) {
          // EARLY EXIT: Authentication not enabled
          return;
        }

        var authenticationPayload = _this2.auth.getAuthentication();
        if (authenticationPayload !== null) {
          dispatch(_this2._loginSync(authenticationPayload));
        } else {
          dispatch(_this2._logoutSync(authenticationPayload));
        }
      };
    }
  }, {
    key: 'requestLogin',
    value: function requestLogin(username, password) {
      var _this3 = this;

      return function (dispatch, getState) {
        if (!_this3.auth) {
          // EARLY EXIT: Authentication not enabled
          return;
        }

        var authenticationPayload = _this3.authentication(getState()).payload;
        dispatch(_this3._loginRequest());
        _this3.auth.requestAuthentication(authenticationPayload, username, password).then(function (authenticationPayload) {
          dispatch(_this3._loginSuccess(authenticationPayload));
        }, function (error) {
          dispatch(_this3._loginError(_this3.auth.getAuthentication(), error));
        });
      };
    }
  }, {
    key: 'requestLogout',
    value: function requestLogout(reason) {
      var _this4 = this;

      return function (dispatch, getState) {
        if (!_this4.auth) {
          // EARLY EXIT: Authentication not enabled
          return;
        }
        if (_this4.notifier) {
          _this4.notifier.onLogout();
        }

        dispatch(_this4._logoutRequest(reason));
        _this4.auth.clearAuthentication().then(function () {
          dispatch(_this4._logoutSuccess(_this4.auth.getAuthentication()));
        }, function (error) {
          dispatch(_this4._logoutError(_this4.auth.getAuthentication(), error));
        });
      };
    }

    /*
     * Action creator for subscribing to a dataSource, filter, and group from an API
     */

  }, {
    key: 'subscribe',
    value: function subscribe(dataSource, group, query, sort, limit, only) {
      var _this5 = this;

      var alias = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;

      group = (0, _constants.groupName)(group);
      alias = (0, _constants.filterDefault)(alias, query, sort, only, limit);
      return function (subscriberObj) {
        return _this5._subscribeInner(subscriberObj, dataSource, group, query, sort, limit, only, alias);
      };
    }
  }, {
    key: '_subscribeInner',
    value: function _subscribeInner(subscribeId, dataSource, group, query, sort, limit, only, alias) {
      var _this6 = this;

      return function (dispatch, getState) {

        var declaration = _this6.dataSources.get(dataSource);
        if (declaration === undefined) {
          throw new Error('Data source ' + dataSource + ' could not be found.');
        }
        if ((typeof declaration === 'undefined' ? 'undefined' : _typeof(declaration)) !== 'object') {
          throw new Error('Data source ' + dataSource + ' was not an object.');
        }
        if (declaration['type'] === undefined) {
          throw new Error('Data source ' + dataSource + ' is missing the required type key.');
        }

        // Update the state with the subscription status (and the query state, if just changing the query)
        dispatch(_this6._subscribe(subscribeId, dataSource, group, query, sort, limit, only, alias, declaration));

        // Check if initial data needs to be loaded, or a cache needs to be refreshed.
        var state = _this6.getState(getState());

        var metaState = state.getIn(['data', dataSource, 'groups', group, 'filters', alias, 'meta']);
        if (metaState === undefined || metaState.hasInitialData === false || metaState.needsUpdate === true) {
          // Issue a full request because data has not yet been received
          var request = _this6.request(dataSource, group, alias, query, sort, limit, only);
          dispatch(request());
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_subscribe',
    value: function _subscribe(subscribeId, dataSource, group, query, sort, limit, only, alias, declaration) {
      return {
        payload: {
          subscribeId: subscribeId,
          dataSource: dataSource,
          group: group,
          query: query,
          sort: sort,
          limit: limit,
          only: only,
          alias: alias
        },
        meta: {
          dataSourceDeclaration: declaration
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_subscribeReducer',
    value: function _subscribeReducer(state, _ref, _ref2) {
      var subscribeId = _ref.subscribeId,
          dataSource = _ref.dataSource,
          group = _ref.group,
          query = _ref.query,
          sort = _ref.sort,
          limit = _ref.limit,
          only = _ref.only,
          alias = _ref.alias;
      var dataSourceDeclaration = _ref2.dataSourceDeclaration;

      var dataSourceState = state.getIn(['data', dataSource]);
      if (dataSourceState !== undefined) {
        // Check if group container is available, or create it
        var groupContainerState = dataSourceState.get('groups');
        if (groupContainerState === undefined) {
          state = state.setIn(['data', dataSource, 'groups'], (0, _immutable.Map)());
        }

        // Check if group is available, or create it
        var groupState = state.getIn(['data', dataSource, 'groups', group]);
        if (groupState === undefined) {
          state = state.setIn(['data', dataSource, 'groups', group], createApiGroupData());
        }

        // Set the filter subscribers
        return state.updateIn(['data', dataSource, 'groups', group], function (gs) {
          return gs.withMutations(function (map) {
            var filterContainerState = map.get('filters');
            if (filterContainerState !== undefined) {
              var filterState = filterContainerState.get(alias);
              if (filterState !== undefined) {
                // Ensure that the filter query is up to date if the filter is using an alias
                filterContainerState = filterContainerState.update(alias, function (fs) {
                  return fs.merge({ query: query, sort: sort, limit: limit, only: only });
                });
              } else {
                filterContainerState = filterContainerState.set(alias, createApiFilterData({ query: query, sort: sort, limit: limit, only: only }));
              }
            } else {
              filterContainerState = (0, _immutable.Map)(_defineProperty({}, alias, createApiFilterData({ query: query, sort: sort, limit: limit, only: only })));
            }

            // Set filter subscribers
            var newFilterContainerState = filterContainerState.update(alias, function (aliasState) {
              var oldSubscriberState = aliasState.get('subscribers');
              var newSubscriberState = oldSubscriberState.add(subscribeId);
              aliasState = aliasState.set('subscribers', oldSubscriberState);

              // If going from zero subscribers to some subscribers, then this is likely reinitializing
              // a cache.  Mark the record as needing a new request.
              if (oldSubscriberState.size === 0) {
                var metaState = aliasState.get('meta');
                metaState = metaState.set('needsUpdate', true);
                aliasState = aliasState.set('meta', metaState);
              }

              return aliasState;
            });

            map.set('filters', newFilterContainerState);
            return map;
          });
        });
      } else {
        var subscriberSet = (0, _immutable.Set)();
        subscriberSet = subscriberSet.add(subscribeId);
        var filterMap = (0, _immutable.Map)(_defineProperty({}, alias, createApiFilterData({ query: query, sort: sort, limit: limit, only: only, subscribers: subscriberSet })));
        var groupMap = (0, _immutable.Map)(_defineProperty({}, group, createApiGroupData({ filters: filterMap })));
        return state.setIn(['data', dataSource], createApiDataSource(dataSource, dataSourceDeclaration, { groups: groupMap }));
      }
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe(dataSource, group, alias) {
      var _this7 = this;

      group = (0, _constants.groupName)(group);
      return function (subscriberObj) {
        return _this7._unsubscribe(subscriberObj, dataSource, group, alias);
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_unsubscribe',
    value: function _unsubscribe(subscribeId, dataSource, group, alias) {
      return {
        payload: {
          subscribeId: subscribeId,
          dataSource: dataSource,
          group: group,
          alias: alias
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_unsubscribeReducer',
    value: function _unsubscribeReducer(state, _ref3) {
      var subscribeId = _ref3.subscribeId,
          dataSource = _ref3.dataSource,
          group = _ref3.group,
          alias = _ref3.alias;

      // Strip out all filters that are now unsubscribed
      var filterState = state.getIn(['data', dataSource, 'groups', group, 'filters', alias]);
      if (filterState !== undefined) {
        var newSubscribers = filterState.subscribers.remove(subscribeId);
        state = state.setIn(['data', dataSource, 'groups', group, 'filters', alias, 'subscribers'], newSubscribers);
      }
      return this._cleanupState(state, dataSource, group);
    }
  }, {
    key: '_cleanupState',
    value: function _cleanupState(state) {
      var dataSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var group = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      var lruCutoff = Math.min(this._lruSequence - _constants.MAX_LRU_SIZE, 0);
      var previous = state;
      if (group !== undefined) {
        state = state.updateIn(['data', dataSource, 'groups', group, 'filters'], function (fs) {
          return fs.withMutations(cleanupFilters({ lruCutoff: lruCutoff }));
        });

        // Double check that the dataSources and groups aren't empty after removal
        if (state !== previous) {
          if (state.getIn(['data', dataSource, 'groups', group, 'filters']).size === 0) {
            state = state.deleteIn(['data', dataSource, 'groups', group]);
          }
          if (state.getIn(['data', dataSource, 'groups']).size === 0) {
            state = state.deleteIn(['data', dataSource]);
          }
        }
      } else if (dataSource !== undefined) {
        state = state.updateIn(['data', dataSource, 'groups'], function (gs) {
          return gs.withMutations(cleanupGroups({ lruCutoff: lruCutoff }));
        });

        // Double check that the dataSources empty after removal
        if (state !== previous) {
          if (state.getIn(['data', dataSource, 'groups']).size === 0) {
            state = state.deleteIn(['data', dataSource]);
          }
        }
      } else {
        state = state.updateIn(['data'], function (ds) {
          return ds.withMutations(cleanupDataSources({ lruCutoff: lruCutoff }));
        });
      }

      return state;
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: 'cleanup',
    value: function cleanup() {
      var dataSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      return {
        payload: {
          dataSource: dataSource,
          group: group
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_cleanupReducer',
    value: function _cleanupReducer(state, _ref4) {
      var dataSource = _ref4.dataSource,
          group = _ref4.group;

      return this._cleanupState(state, dataSource, group);
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_serverDataAvailable',
    value: function _serverDataAvailable(dataSource, group, alias) {
      return {
        payload: {
          dataSource: dataSource,
          group: group,
          alias: alias
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_serverDataAvailableReducer',
    value: function _serverDataAvailableReducer(state, _ref5) {
      var dataSource = _ref5.dataSource,
          group = _ref5.group,
          alias = _ref5.alias;

      var dataSourceState = state.getIn(['data', dataSource]);
      if (!dataSourceState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var groupState = dataSourceState.getIn(['groups', group]);
      if (!groupState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var filterState = groupState.getIn(['filters', alias]);
      if (!filterState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      return state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'meta'], function (metaState) {
        return metaState.merge({
          needsUpdate: true
        });
      });
    }
  }, {
    key: 'maybeRequest',
    value: function maybeRequest(dataSource, group, alias) {
      var _this8 = this;

      group = (0, _constants.groupName)(group);
      // Purposely allow filterQuery to be undefined.  It will be looked up if it's not available
      return function () {
        return _this8._maybeRequestInner(dataSource, group, alias);
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_maybeRequestInner',
    value: function _maybeRequestInner(dataSource, group, alias) {
      var _this9 = this;

      return function (dispatch, getState) {
        // Before dispatching the data available request, check the state of the world.  A new request is required if:
        // - There is currently no data available (metaState === undefined)
        // - There is not already a request in flight (metaState.loading === false)
        // - A different maybeRequest( ... ) hasn't already made a new request (metaState.needsUpdate === false)
        var state = _this9.getState(getState());

        var metaState = state.getIn(['data', dataSource, 'groups', group, 'filters', alias, 'meta']);
        var requiresRequest = metaState === undefined || metaState.loading === false && metaState.needsUpdate === false;

        dispatch(_this9._serverDataAvailable(dataSource, group, alias));
        if (requiresRequest) {
          // If the data for this filter isn't currently loaded or if there is not currently a request in flight,
          // then go get the new data for this filter, if we have a query.
          var request = _this9.request(dataSource, group, alias);
          dispatch(request());
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_requestModel',
    value: function _requestModel(dataSource, group, declaration) {
      var alias = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      var query = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
      var sort = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
      var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;
      var only = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : undefined;

      group = (0, _constants.groupName)(group);
      alias = (0, _constants.filterDefault)(alias, query, sort, only, limit);
      return {
        payload: {
          dataSource: dataSource,
          group: group
        },
        meta: {
          dataSourceDeclaration: declaration,
          alias: alias,
          query: query,
          sort: sort,
          limit: limit,
          only: only
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_requestModelReducer',
    value: function _requestModelReducer(state, _ref6, _ref7) {
      var dataSource = _ref6.dataSource,
          group = _ref6.group;
      var dataSourceDeclaration = _ref7.dataSourceDeclaration,
          alias = _ref7.alias,
          _ref7$query = _ref7.query,
          query = _ref7$query === undefined ? undefined : _ref7$query,
          _ref7$sort = _ref7.sort,
          sort = _ref7$sort === undefined ? undefined : _ref7$sort,
          _ref7$limit = _ref7.limit,
          limit = _ref7$limit === undefined ? undefined : _ref7$limit,
          _ref7$only = _ref7.only,
          only = _ref7$only === undefined ? undefined : _ref7$only;

      var dataSourceState = state.getIn(['data', dataSource]);
      if (dataSourceState !== undefined) {
        // Check if group container is available, or create it
        var groupContainerState = dataSourceState.get('groups');
        if (groupContainerState === undefined) {
          state = state.setIn(['data', dataSource, 'groups'], (0, _immutable.Map)());
        }

        // Check if group is available, or create it
        var groupState = state.getIn(['data', dataSource, 'groups', group]);
        if (groupState === undefined) {
          state = state.setIn(['data', dataSource, 'groups', group], createApiGroupData());
        }

        if (state.getIn(['data', dataSource, 'groups', group, 'filters', alias]) === undefined) {
          if (query === undefined && sort === undefined && only === undefined) {
            // EARLY EXIT: Query/sort/only has not been defined yet.
            return state;
          }
        }

        // Set the filter if it was passed
        return state.updateIn(['data', dataSource, 'groups', group], function (gs) {
          return gs.withMutations(function (map) {
            var filterContainerState = map.get('filters');
            if (filterContainerState !== undefined) {
              var filterState = filterContainerState.get(alias);
              if (filterState !== undefined) {
                // Filter exists, update any passed in information
                if (query !== undefined) {
                  filterState = filterState.set('query', query);
                }
                if (sort !== undefined) {
                  if (_immutable.Set.isSet(sort) || _immutable.List.isList(sort) || Array.isArray(only)) {
                    var currentSort = filterState.get('sort');
                    if (!_immutable.List.isList(currentSort)) {
                      // Current stored state might be a string, just replace it.
                      filterState = filterState.set('sort', (0, _immutable.List)(sort));
                    } else if (currentSort.merge(sort) !== currentSort) {
                      filterState = filterState.set('sort', (0, _immutable.List)(sort));
                    }
                  } else {
                    filterState = filterState.set('sort', sort);
                  }
                }
                if (limit !== undefined) {
                  filterState = filterState.set('limit', limit);
                }
                if (only !== undefined) {
                  // Merge only data -- this is to prevent
                  if (_immutable.Set.isSet(only) || _immutable.List.isList(only) || Array.isArray(only)) {
                    var currentOnly = filterState.get('only');
                    var newOnly = (0, _immutable.Set)(only);
                    if (!_immutable.List.isList(currentOnly)) {
                      // Current stored state might be a string, just replace it.
                      filterState = filterState.set('only', newOnly);
                    } else if (currentOnly.merge(newOnly) !== currentOnly) {
                      filterState = filterState.set('only', newOnly);
                    }
                  } else {
                    filterState = filterState.set('only', only);
                  }
                }

                // ... and set the loading state
                filterState = filterState.update('meta', function (ms) {
                  return ms.merge({
                    loading: true,
                    loadingError: null
                  });
                });
              } else {
                // Filter doesn't exist, create a new one
                filterState = createApiFilterData({ query: query, sort: sort, limit: limit, only: only });
              }
              filterContainerState = filterContainerState.set(alias, filterState);
            } else {
              filterContainerState = (0, _immutable.Map)(_defineProperty({}, alias, createApiFilterData({ query: query, sort: sort, limit: limit, only: only })));
            }

            // Set filters
            map.set('filters', filterContainerState);

            return map;
          });
        });
      } else {
        var filterMap = (0, _immutable.Map)(_defineProperty({}, alias, createApiFilterData({ query: query, sort: sort, limit: limit, only: only })));
        var groupMap = (0, _immutable.Map)(_defineProperty({}, group, createApiGroupData({ filters: filterMap })));
        return state.setIn(['data', dataSource], createApiDataSource(dataSource, dataSourceDeclaration, { groups: groupMap }));
      }
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveModel',
    value: function _receiveModel(dataSource, group, model) {
      return {
        payload: model,
        meta: {
          dataSource: dataSource,
          group: group
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveModelReducer',
    value: function _receiveModelReducer(state, model, _ref8) {
      var dataSource = _ref8.dataSource,
          group = _ref8.group;

      var groupState = state.getIn(['data', dataSource, 'groups', group]);
      if (!groupState) {
        // EARLY EXIT: Group no longer exists.  May have been evicted.
        return state;
      }

      // Set group state
      state = state.updateIn(['data', dataSource, 'groups', group], function (groupState) {
        return groupState.merge({
          model: model,
          modelName: model.modelName,
          loading: false,
          loadingUnauthorized: false,
          loadingError: null
        });
      });

      // Propogate to filter state
      return state.updateIn(['data', dataSource, 'groups', group, 'filters'], function (filterContainerState) {
        return filterContainerState.withMutations(function (map) {
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = map[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var _step7$value = _slicedToArray(_step7.value, 2),
                  filterKey = _step7$value[0],
                  filter = _step7$value[1];

              map.set(filterKey, filter.update('meta', function (ms) {
                return ms.merge({
                  model: model,
                  modelName: model.modelName
                });
              }));
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }

          return map;
        });
      });
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveModelError',
    value: function _receiveModelError(dataSource, group, error) {
      return {
        payload: error,
        meta: {
          dataSource: dataSource,
          group: group
        }
      };
    }
  }, {
    key: '_receiveModelErrorReducer',
    value: function _receiveModelErrorReducer(state, error, _ref9) {
      var dataSource = _ref9.dataSource,
          group = _ref9.group;

      var groupState = state.getIn(['data', dataSource, 'groups', group]);
      if (!groupState) {
        // EARLY EXIT: Group no longer exists.  May have been evicted.
        return state;
      }

      // Set group state
      state = state.updateIn(['data', dataSource, 'groups', group], function (groupState) {
        return groupState.merge({ loading: false, loadingUnauthorized: false, loadingError: error });
      });

      // Propogate to filter state
      return state.updateIn(['data', dataSource, 'groups', group, 'filters'], function (filterContainerState) {
        return filterContainerState.withMutations(function (map) {
          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = map[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var _step8$value = _slicedToArray(_step8.value, 2),
                  filterKey = _step8$value[0],
                  filter = _step8$value[1];

              map.set(filterKey, filter.update('meta', function (ms) {
                return ms.merge({
                  loading: false,
                  loadingError: error,
                  model: null,
                  modelName: ""
                });
              }));
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }

          return map;
        });
      });
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_request',
    value: function _request(dataSource, group, alias) {
      var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      var sort = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
      var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
      var only = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;

      group = (0, _constants.groupName)(group);
      return {
        payload: {
          group: group,
          dataSource: dataSource,
          alias: alias,
          query: query,
          sort: sort,
          limit: limit,
          only: only
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_requestReducer',
    value: function _requestReducer(state, _ref10) {
      var dataSource = _ref10.dataSource,
          group = _ref10.group,
          alias = _ref10.alias,
          query = _ref10.query,
          sort = _ref10.sort,
          limit = _ref10.limit,
          only = _ref10.only;

      var groupState = state.getIn(['data', dataSource, 'groups', group]);
      if (!groupState || !groupState.model) {
        // EARLY EXIT: Group no longer exists.  May have been evicted.
        return state;
      }

      // Get the next sequence for use in the LRU Caching system
      var lruSequence = this._nextLRU();

      var filterContainerState = state.getIn(['data', dataSource, 'groups', group, 'filters']);
      if (filterContainerState === undefined) {
        // Filter container state is undefined, make the map with the new data and make sure to propogate the group
        // info meta
        return state.setIn(['data', dataSource, 'groups', group, 'filters'], (0, _immutable.Map)(_defineProperty({}, alias, createApiFilterData({
          alias: alias,
          query: query,
          sort: sort,
          limit: limit,
          only: only,
          model: groupState.model,
          modelName: groupState.modelName,
          loading: groupState.loading,
          loadingUnauthorized: groupState.loadingUnauthorized,
          loadingError: groupState.loadingError,
          lruSequence: lruSequence,
          lastRequestTimestamp: Date.now()
        }))));
      } else {
        // Filter container exists, check if filter exists
        var filterState = filterContainerState.get(alias);
        if (filterState !== undefined) {
          // Filter already exists, just update the query, loading status and clear the update status.
          state = state.updateIn(['data', dataSource, 'groups', group, 'filters', alias], function (fs) {
            var newValues = {};
            if (query !== undefined) {
              newValues['query'] = query;
            }
            if (limit !== undefined) {
              newValues['limit'] = limit;
            }

            fs = fs.merge(newValues);

            // Sort requires special logic because it's a replacement if it's not exactly equal
            if (sort !== undefined) {
              if (_immutable.Set.isSet(sort) || _immutable.List.isList(sort) || Array.isArray(only)) {
                var currentSort = fs.get('sort');
                if (!_immutable.List.isList(currentSort)) {
                  // Current stored state might be a string, just replace it.
                  fs = fs.set('sort', (0, _immutable.List)(sort));
                } else if (currentSort.merge(sort) !== currentSort) {
                  // Only has changed, replace it.
                  fs = fs.set('sort', (0, _immutable.List)(sort));
                }
              } else {
                // Sort is probably a string, merge can figure it out
                fs = fs.set('sort', sort);
              }
            }

            // Only requires special logic because it's a replacement if it's not exactly equal
            if (only !== undefined) {
              if (_immutable.Set.isSet(only) || _immutable.List.isList(only) || Array.isArray(only)) {
                var currentOnly = fs.get('only');
                var newOnly = (0, _immutable.Set)(only);
                if (!_immutable.List.isList(currentOnly)) {
                  // Current stored state might be a string, just replace it.
                  fs = fs.set('only', newOnly);
                } else if (currentOnly.merge(newOnly) !== currentOnly) {
                  // Only has changed, replace it.
                  fs = fs.set('only', newOnly);
                }
              } else {
                // Only is probably a string, merge can figure it out.
                fs = fs.set('only', only);
              }
            }

            return fs;
          });

          return state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'meta'], function (metaState) {
            return metaState.merge({
              model: groupState.model,
              modelName: groupState.modelName,
              loading: true,
              needsUpdate: false,
              lruSequence: lruSequence,
              lastRequestTimestamp: Date.now()
            });
          });
        } else {
          // Filter doesn't exist, add it in and make sure to propogate the group info into meta
          return state.setIn(['data', dataSource, 'groups', group, 'filters', alias], createApiFilterData({
            alias: alias,
            query: query,
            sort: sort,
            limit: limit,
            only: only,
            model: groupState.model,
            modelName: groupState.modelName,
            loading: groupState.loading,
            loadingUnauthorized: groupState.loadingUnauthorized,
            loadingError: groupState.loadingError,
            lruSequence: lruSequence,
            lastRequestTimestamp: Date.now()
          }));
        }
      }
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receive',
    value: function _receive(dataSource, group, alias, data, lastModified, etag) {
      return {
        payload: data,
        meta: {
          dataSource: dataSource,
          group: group,
          alias: alias,
          lastModified: lastModified,
          etag: etag
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveReducer',
    value: function _receiveReducer(state, data, _ref11) {
      var group = _ref11.group,
          alias = _ref11.alias,
          dataSource = _ref11.dataSource,
          lastModified = _ref11.lastModified,
          etag = _ref11.etag;

      var dataSourceState = state.getIn(['data', dataSource]);
      if (!dataSourceState) {
        // URL no longer exists.  May have been evicted.
        return state;
      }

      var groupState = dataSourceState.getIn(['groups', group]);
      if (!groupState || !groupState.model) {
        // Group no longer exists.  May have been evicted.
        return state;
      }

      var filterState = groupState.getIn(['filters', alias]);
      if (!filterState) {
        // Filter no longer exists.  May have been evicted.
        return state;
      }

      // Build reference proxy
      var reference = this._buildReferenceProxy({ state: state });

      // Determine if a sort was specified
      var ordered = filterState.sort !== undefined;

      // Update the selected data source with
      state = state.setIn(['data', dataSource, 'groups', group, 'filters', alias], filterState.withMutations(function (map) {
        // Check payload state and setup Map for a collection
        var payload = map.get('payload');
        var only = map.get('only');
        var meta = map.get('meta');

        var itemCount = 0;
        var loadingError = null;

        try {
          // Reconcile the payload
          if (dataSourceState.dataSourceType === _constants.DATA_SOURCE_TYPES.COLLECTION) {
            // Collection of items
            if (payload === undefined) {
              payload = createServerCollection(groupState.model, data, { only: only, ordered: ordered, reference: reference });
            } else {
              payload = payload.withMutations(updateServerCollection(groupState.model, data, { only: only, ordered: ordered, reference: reference }));
            }
            itemCount = payload.countItems();
          } else if (dataSourceState.dataSourceType === _constants.DATA_SOURCE_TYPES.ITEM) {
            // Single item
            var item = data;
            if (payload === undefined) {
              payload = createServerItem(groupState.model, _constants.STANDALONE_ITEM, item, { only: only, ordered: ordered, reference: reference });
            } else {
              payload = payload.withMutations(updateServerItem(groupState.model, item, { only: only, ordered: ordered, reference: reference }));
            }
            itemCount = item === undefined ? 0 : 1;
          } else {
            throw new Error('Unknown dataSourceType: ' + dataSourceState.dataSourceType);
          }
        } catch (error) {
          if (process.env.NODE_ENV !== 'production') {
            console.error('receiveReducerError: ', dataSource, group, alias, error);
          }
          loadingError = error;
        }

        if (process.env.NODE_ENV !== 'production') {
          if (typeof DEBUG_OUTPUT !== 'undefined' && DEBUG_OUTPUT) {
            var oldPayload = map.get('payload');
            if (!!oldPayload && payload !== oldPayload) {
              console.log('Updated: ' + dataSource + ' - ' + group + ' - ' + alias + ' New:', payload.toJS(), 'Old:', oldPayload.toJS(), 'Diff:', (0, _deepObjectDiff.diff)(payload.toJS(), oldPayload.toJS()));
            }
            if (!oldPayload && payload !== oldPayload) {
              console.log('Added: ' + dataSource + ' - ' + group + ' - ' + alias + ' New:', payload.toJS());
            }
          }
        }

        map.set('payload', payload);

        // Set metadata
        map.set('meta', meta.merge({
          hasInitialData: true,
          itemCount: itemCount,
          loading: false,
          loadingUnauthorized: false,
          loadingError: loadingError,
          lastModified: lastModified,
          etag: etag
        }));

        return map;
      }));

      return this._verifyRelated(state, dataSource);
    }
  }, {
    key: '_verifyRelated',
    value: function _verifyRelated(state, dataSource) {
      // Check if any related entries need to be validated
      var declaration = this.dataSources.get(dataSource);
      if (declaration === undefined) {
        // EARLY EXIT: No data source found
        return state;
      }

      // Check if there are any related data sources
      var relatedDataSources = (0, _utils.getMapKey)(declaration, 'verifyRelated');
      if (relatedDataSources === undefined || relatedDataSources.length === 0) {
        // EARLY EXIT: Data source didn't have any related verification.
        return state;
      }

      // Verify related data sources when loading
      if (process.env.NODE_ENV !== 'production') {
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
          for (var _iterator9 = relatedDataSources[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var related = _step9.value;

            if (related === dataSource) {
              throw new Error('Can\'t pass same data source ' + related);
            }
            if (!this.dataSources.has(related)) {
              throw new Error('Unrecognized related data source ' + related);
            }
          }
        } catch (err) {
          _didIteratorError9 = true;
          _iteratorError9 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion9 && _iterator9.return) {
              _iterator9.return();
            }
          } finally {
            if (_didIteratorError9) {
              throw _iteratorError9;
            }
          }
        }
      }

      // Build a state reference
      var reference = this._buildReferenceProxy({ state: state });

      // Loop through related loaded data and re-run the verification methods
      state = state.update('data', function (dataState) {
        return dataState.withMutations(function (map) {
          var dataSourceState = void 0,
              groupsState = void 0,
              newGroupsState = void 0,
              filtersState = void 0,
              newFiltersState = void 0;
          var _iteratorNormalCompletion10 = true;
          var _didIteratorError10 = false;
          var _iteratorError10 = undefined;

          try {
            for (var _iterator10 = relatedDataSources[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
              var _dataSource = _step10.value;

              dataSourceState = map.get(_dataSource);
              if (dataSourceState === undefined) {
                continue;
              }

              groupsState = dataSourceState.get('groups');
              newGroupsState = groupsState;
              var _iteratorNormalCompletion11 = true;
              var _didIteratorError11 = false;
              var _iteratorError11 = undefined;

              try {
                for (var _iterator11 = groupsState[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                  var _step11$value = _slicedToArray(_step11.value, 2),
                      group = _step11$value[0],
                      groupState = _step11$value[1];

                  filtersState = groupState.get('filters');
                  newFiltersState = filtersState;
                  var _iteratorNormalCompletion12 = true;
                  var _didIteratorError12 = false;
                  var _iteratorError12 = undefined;

                  try {
                    for (var _iterator12 = filtersState[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                      var _step12$value = _slicedToArray(_step12.value, 2),
                          filter = _step12$value[0],
                          filterState = _step12$value[1];

                      var payload = filterState.get('payload');
                      if (payload === undefined) {
                        continue;
                      }
                      if (dataSourceState.dataSourceType === _constants.DATA_SOURCE_TYPES.COLLECTION) {
                        payload = payload.withMutations(validateCollection(groupState.model, { reference: reference }));
                      } else if (dataSourceState.dataSourceType === _constants.DATA_SOURCE_TYPES.ITEM) {
                        payload = payload.withMutations(validateItem(groupState.model, { reference: reference }));
                      } else {
                        throw new Error('Unknown dataSourceType: ' + dataSourceState.dataSourceType);
                      }

                      filterState = filterState.set('payload', payload);

                      newFiltersState = newFiltersState.set(filter, filterState);
                    }
                  } catch (err) {
                    _didIteratorError12 = true;
                    _iteratorError12 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion12 && _iterator12.return) {
                        _iterator12.return();
                      }
                    } finally {
                      if (_didIteratorError12) {
                        throw _iteratorError12;
                      }
                    }
                  }

                  newGroupsState = newGroupsState.setIn([group, 'filters'], newFiltersState);
                }
              } catch (err) {
                _didIteratorError11 = true;
                _iteratorError11 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion11 && _iterator11.return) {
                    _iterator11.return();
                  }
                } finally {
                  if (_didIteratorError11) {
                    throw _iteratorError11;
                  }
                }
              }

              dataSourceState = dataSourceState.set('groups', newGroupsState);

              map.set(dataSourceState);
            }
          } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion10 && _iterator10.return) {
                _iterator10.return();
              }
            } finally {
              if (_didIteratorError10) {
                throw _iteratorError10;
              }
            }
          }

          return map;
        });
      });

      return state;
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveError',
    value: function _receiveError(dataSource, group, alias, error) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('receiveError: ', dataSource, group, alias, error);
      }

      return {
        payload: error,
        meta: {
          alias: alias,
          group: group,
          dataSource: dataSource
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveErrorReducer',
    value: function _receiveErrorReducer(state, error, _ref12) {
      var group = _ref12.group,
          alias = _ref12.alias,
          dataSource = _ref12.dataSource;

      var groupState = state.getIn(['data', dataSource, 'groups', group]);
      if (!groupState) {
        // EARLY EXIT: State no longer exists.  May have been evicted.
        return state;
      }

      var filterState = groupState.getIn(['filters', alias]);
      if (!filterState) {
        // EARLY EXIT: State no longer exists.  May have been evicted.
        return state;
      }

      return state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'meta'], function (metaState) {
        return metaState.merge({
          loading: false,
          loadingUnauthorized: false,
          loadingError: error
        });
      });
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveUnauthorized',
    value: function _receiveUnauthorized(dataSource, group, alias, data) {
      return {
        payload: data,
        meta: {
          alias: alias,
          group: group,
          dataSource: dataSource
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveUnauthorizedReducer',
    value: function _receiveUnauthorizedReducer(state, data, _ref13) {
      var group = _ref13.group,
          alias = _ref13.alias,
          dataSource = _ref13.dataSource;

      var groupState = state.getIn(['data', dataSource, 'groups', group]);
      if (!groupState) {
        // EARLY EXIT: State no longer exists.  May have been evicted.
        return state;
      }

      var filterState = groupState.getIn(['filters', alias]);
      if (!filterState) {
        // EARLY EXIT: State no longer exists.  May have been evicted.
        return state;
      }

      return state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'meta'], function (metaState) {
        return metaState.merge({
          loading: false,
          loadingUnauthorized: true,
          loadingError: data
        });
      });
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveModelUnauthorized',
    value: function _receiveModelUnauthorized(dataSource, group, data) {
      return {
        payload: data,
        meta: {
          group: group,
          dataSource: dataSource
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveModelUnauthorizedReducer',
    value: function _receiveModelUnauthorizedReducer(state, data, _ref14) {
      var group = _ref14.group,
          dataSource = _ref14.dataSource;

      return state.updateIn(['data', dataSource, 'groups', group], function (groupState) {
        return groupState.merge({ loading: false, loadingUnauthorized: true, loadingError: data });
      });
    }

    /*
     * Request model from the server for a given dataSource and group
     */

  }, {
    key: 'requestModel',
    value: function requestModel(dataSource, group) {
      var _this10 = this;

      group = (0, _constants.groupName)(group);
      return function () {
        return _this10._requestModelInner(dataSource, group, false);
      };
    }

    /*
     * Request data from the server for a given dataSource, group, and filter
     */

  }, {
    key: 'request',
    value: function request(dataSource, group) {
      var alias = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      var sort = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

      var _this11 = this;

      var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
      var only = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;

      group = (0, _constants.groupName)(group);
      if (alias === undefined) {
        alias = (0, _constants.filterDefault)(alias, query, sort, only, limit);
      }
      return function () {
        return _this11._requestModelInner(dataSource, group, true, alias, query, sort, limit, only);
      };
    }
  }, {
    key: '_requestModelInner',
    value: function _requestModelInner(dataSource, group, loadData) {
      var alias = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      var query = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
      var sort = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

      var _this12 = this;

      var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;
      var only = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : undefined;

      if (loadData === true && alias === undefined) {
        throw new Error("Must include filter name and query if a data request is to be executed after the model is loaded.");
      }

      return function (dispatch, getState) {
        var state = _this12.getState(getState());
        var groupState = state.getIn(['data', dataSource, 'groups', group]);
        if (!!groupState && !!groupState.model) {
          // Group (and model) is already loaded.  Just use the existing model.
          if (loadData === true) {
            // Create fake promise
            return Promise.resolve().then(function (_) {
              _this12._loadData(dispatch, getState, dataSource, groupState.model, group, alias);
            });
          }
        } else {
          // Group (and model) has not yet been loaded.  Go and load it.
          var declaration = _this12.dataSources.get(dataSource);
          if (declaration['type'] === undefined) {
            throw new Error('Data source ' + dataSource + ' is missing the required type key.');
          }

          var filterState = _this12.getState(getState()).getIn(['data', dataSource, 'groups', group, 'filters', alias]);
          if (query === undefined) {
            query = filterState.query;
          }
          if (sort === undefined) {
            sort = filterState.sort;
          }
          if (limit === undefined) {
            limit = filterState.limit;
          }
          if (only === undefined) {
            only = filterState.only;
          }

          var options = {
            onRequest: _this12._requestModelOnRequest(dispatch, dataSource, group, declaration, alias, query, sort, limit, only),
            onReceive: _this12._requestModelOnReceive(dispatch, getState, dataSource, group, alias, loadData),
            onReceiveUnchanged: _this12._requestModelOnReceive(dispatch, getState, dataSource, group, alias, loadData), // TODO - handle this differently?!
            onReceiveUnauthenticated: _this12._requestModelOnReceiveUnauthenticated(dispatch, dataSource, group),
            onReceiveUnauthorized: _this12._requestModelOnReceiveUnauthorized(dispatch, dataSource, group),
            onError: _this12._requestModelOnReceiveError(dispatch, dataSource, group)
          };
          // Add authentication, if required
          if (_this12.auth) {
            options['getAuthenticationHeaders'] = _this12._getAuthenticationHeaders(getState);
          }
          // Add group, if it's passed.
          if (group !== _constants.DEFAULT_API_GROUP_NAME) {
            options['group'] = group;
          }
          // Add filter (query), if it's passed
          if (query !== undefined && query !== _constants.DEFAULT_API_FILTER_NAME) {
            options['filter'] = query;
          }

          if (only !== undefined) {
            options['only'] = only;
          }

          return _this12.modelLoader(dataSource, declaration, options);
        }
      };
    }
  }, {
    key: '_requestModelOnRequest',
    value: function _requestModelOnRequest(dispatch, dataSource, group, declaration) {
      var alias = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
      var query = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
      var sort = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;

      var _this13 = this;

      var limit = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : undefined;
      var only = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : undefined;

      return function () {
        dispatch(_this13._requestModel(dataSource, group, declaration, alias, query, sort, limit, only));
      };
    }
  }, {
    key: '_requestModelOnReceive',
    value: function _requestModelOnReceive(dispatch, getState, dataSource, group, alias, loadData) {
      var _this14 = this;

      return function (model) {
        dispatch(_this14._receiveModel(dataSource, group, model));
        if (loadData === true) {
          _this14._loadData(dispatch, getState, dataSource, model, group, alias);
        }
      };
    }
  }, {
    key: '_requestModelOnReceiveUnauthenticated',
    value: function _requestModelOnReceiveUnauthenticated(dispatch, dataSource, group) {
      var _this15 = this;

      return function (data) {
        _this15.requestLogout(data)(dispatch);
        //dispatch(this._receiveModelError(dataSource, group, error)); // TODO should this be here?
      };
    }
  }, {
    key: '_requestModelOnReceiveUnauthorized',
    value: function _requestModelOnReceiveUnauthorized(dispatch, dataSource, group) {
      var _this16 = this;

      return function (data) {
        dispatch(_this16._receiveModelUnauthorized(dataSource, group, data));
      };
    }
  }, {
    key: '_requestModelOnReceiveError',
    value: function _requestModelOnReceiveError(dispatch, dataSource, group) {
      var _this17 = this;

      return function (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('moduleReceiverError: ', dataSource, group, error);
        }
        dispatch(_this17._receiveModelError(dataSource, group, error));
      };
    }
  }, {
    key: '_getAuthenticationHeaders',
    value: function _getAuthenticationHeaders(getState) {
      var _this18 = this;

      return function () {
        if (!_this18.auth) {
          throw new Error("Invalid use of authentication headers");
        }
        var authenticationPayload = _this18.authentication(getState()).payload;
        return _this18.auth.checkAuthentication(authenticationPayload).then(function (newAuthenticationPayload) {
          return Promise.resolve(_this18.auth.getAuthenticationHeaders(newAuthenticationPayload));
        });
      };
    }
  }, {
    key: '_getRequestFilterMetaStateSelector',
    value: function _getRequestFilterMetaStateSelector(dataSource, group, alias) {
      return (0, _reselect.createSelector)(this.getState, function (state) {
        return state.getIn(['data', dataSource, 'groups', group, 'filters', alias, 'meta']);
      });
    }
  }, {
    key: '_loadData',
    value: function _loadData(dispatch, getState, dataSource, model, group, alias) {

      var declaration = this.dataSources.get(dataSource);
      if (declaration['type'] === undefined) {
        throw new Error('Data source ' + dataSource + ' is missing the required type key.');
      }

      var filterState = this.getState(getState()).getIn(['data', dataSource, 'groups', group, 'filters', alias]);
      if (filterState === undefined) {
        // EARLY EXIT: No payload?  Nothing to write.
        return Promise.resolve();
      }

      if (filterState.query === this.disabledFilterSentinel) {
        // EARLY EXIT: The filter is disabled, so there is nothing to do.
        return Promise.resolve();
      }

      // Reset the default filter back to undefined before sending out to the reader
      var options = {
        onRequest: this._requestOnRequest(dispatch, dataSource, group, alias),
        onReceive: this._requestOnReceive(dispatch, getState, dataSource, group, alias),
        onReceiveUnchanged: this._requestOnReceiveUnchanged(dispatch, getState, dataSource, group, alias),
        onReceiveUnauthenticated: this._requestOnReceiveUnauthenticated(dispatch, dataSource, group, alias),
        onReceiveUnauthorized: this._requestOnReceiveUnauthorized(dispatch, dataSource, group, alias),
        onError: this._requestOnReceiveError(dispatch, dataSource, group, alias)
      };
      if (this.auth) {
        options['getAuthenticationHeaders'] = this._getAuthenticationHeaders(getState);
      }
      // Add filter (query), if it's passed.
      if (alias !== _constants.DEFAULT_API_FILTER_NAME) {
        options['filter'] = filterState.query;
        options['sort'] = filterState.sort;
        options['limit'] = filterState.limit;
        options['only'] = filterState.only;
      }
      // Add group, if it's passed.
      if (group !== _constants.DEFAULT_API_GROUP_NAME) {
        options['group'] = group;
      }

      // HACK: Inject all as a way to get page_size all.
      if (options['limit'] === undefined && declaration.type === _constants.DATA_SOURCE_TYPES.COLLECTION) {
        options['limit'] = 'all';
      }

      // Add filter state and etag
      var filterMetaSelector = this._getRequestFilterMetaStateSelector(dataSource, group, alias);
      var filterMetaState = filterMetaSelector(getState());
      if (filterMetaState !== undefined) {
        if (filterMetaState.lastModified !== undefined) {
          options['lastModified'] = filterMetaState.lastModified;
        }
        if (filterMetaState.etag !== undefined) {
          options['etag'] = filterMetaState.etag;
        }
      }

      return this.dataReader(dataSource, declaration, model, options);
    }
  }, {
    key: '_requestOnRequest',
    value: function _requestOnRequest(dispatch, dataSource, group, alias) {
      var _this19 = this;

      return function () {
        return dispatch(_this19._request(dataSource, group, alias));
      };
    }
  }, {
    key: '_requestOnReceive',
    value: function _requestOnReceive(dispatch, getState, dataSource, group, alias) {
      var _this20 = this;

      return function (data, lastModified, etag) {
        dispatch(_this20._receive(dataSource, group, alias, data, lastModified, etag));

        // A notification may have come in while the data was in flight.  Get the selector for this dataSource, filter,
        // and group and then check if the data needs to be requested again.
        var needsRequest = _this20._needsRequest(dataSource, group, alias);
        if (needsRequest(getState())) {
          var request = _this20.request(dataSource, group, alias);
          dispatch(request());
        }
      };
    }
  }, {
    key: '_requestOnReceiveUnchanged',
    value: function _requestOnReceiveUnchanged(dispatch, getState, dataSource, group, alias) {
      var _this21 = this;

      return function (data) {
        // TODO: Maybe do something with Not Modified data, but generally this just means our current state is up to date.

        // A notification may have come in while the data was in flight.  Get the selector for this dataSource, filter,
        // and group and then check if the data needs to be requested again.
        var needsRequest = _this21._needsRequest(dataSource, group, alias);
        if (needsRequest(getState())) {
          var request = _this21.request(dataSource, group, alias);
          dispatch(request());
        }
      };
    }
  }, {
    key: '_requestOnReceiveUnauthenticated',
    value: function _requestOnReceiveUnauthenticated(dispatch, dataSource, group, alias) {
      var _this22 = this;

      return function (data) {
        _this22.requestLogout(data)(dispatch);
        //dispatch(this._receiveError(dataSource, group, alias, data)); // TODO should this be here?
      };
    }
  }, {
    key: '_requestOnReceiveUnauthorized',
    value: function _requestOnReceiveUnauthorized(dispatch, dataSource, group, alias) {
      var _this23 = this;

      return function (data) {
        dispatch(_this23._receiveUnauthorized(dataSource, group, alias, data));
      };
    }
  }, {
    key: '_needsRequest',
    value: function _needsRequest(dataSource, group, alias) {
      return (0, _reselect.createSelector)(this.getState, function (state) {
        var groupState = state.getIn(['data', dataSource, 'groups', group, 'filters', alias, 'meta']);
        return groupState !== undefined && groupState.needsUpdate === true;
      });
    }
  }, {
    key: '_requestOnReceiveError',
    value: function _requestOnReceiveError(dispatch, dataSource, group, alias) {
      var _this24 = this;

      return function (error) {
        dispatch(_this24._receiveError(dataSource, group, alias, error));
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: 'addDraft',
    value: function addDraft(dataSource, group, alias, initialValues) {
      group = (0, _constants.groupName)(group);
      return {
        payload: initialValues,
        meta: {
          dataSource: dataSource,
          group: group,
          alias: alias
        }
      };
    }
  }, {
    key: '_addDraftReducer',
    value: function _addDraftReducer(state, initialValues, _ref15) {
      var group = _ref15.group,
          alias = _ref15.alias,
          dataSource = _ref15.dataSource;

      var dataSourceState = state.getIn(['data', dataSource]);
      if (!dataSourceState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      if (dataSourceState.dataSourceType !== _constants.DATA_SOURCE_TYPES.COLLECTION) {
        throw new Error('Cannot add a draft.  Adding is only supported for collections.');
      }

      var groupState = dataSourceState.getIn(['groups', group]);
      if (!groupState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var filterState = groupState.getIn(['filters', alias]);
      if (!filterState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var only = filterState.get('only');

      // Create a new insert ID and update the meta info for this filter.
      var reducerID = void 0;
      state = state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'meta', 'lastInsertKey'], function (keyState) {
        reducerID = keyState + 1;
        return reducerID;
      });
      reducerID = 'new_' + reducerID;

      // Build reference proxy
      var reference = this._buildReferenceProxy({ state: state });

      // Add the new draft item
      state = state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'payload', 'items', reducerID], function (payloadState) {
        return createDraftItem(groupState.model, reducerID, initialValues, { only: only, reference: reference });
      });

      // Re-count the items into meta
      var items = state.getIn(['data', dataSource, 'groups', group, 'filters', alias, 'payload', 'items']);
      var itemCount = items.size;

      return state.setIn(['data', dataSource, 'groups', group, 'filters', alias, 'meta', 'itemCount'], itemCount);
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: 'removeDraft',
    value: function removeDraft(dataSource, group, alias, id) {
      group = (0, _constants.groupName)(group);
      return {
        payload: id,
        meta: {
          dataSource: dataSource,
          group: group,
          alias: alias,
          id: id
        }
      };
    }
  }, {
    key: '_removeDraftReducer',
    value: function _removeDraftReducer(state, id, _ref16) {
      var group = _ref16.group,
          alias = _ref16.alias,
          dataSource = _ref16.dataSource;

      var dataSourceState = state.getIn(['data', dataSource]);
      if (!dataSourceState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      if (dataSourceState.dataSourceType !== _constants.DATA_SOURCE_TYPES.COLLECTION) {
        throw new Error('Cannot remove a draft.  Removing is only supported for collections.');
      }

      var groupState = dataSourceState.getIn(['groups', group]);
      if (!groupState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var filterState = groupState.getIn(['filters', alias]);
      if (!filterState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      state = state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'payload'], function (payload) {
        return payload.mutateItem(id, removeDraftItem());
      });

      // Re-count the items into meta
      var items = state.getIn(['data', dataSource, 'groups', group, 'filters', alias, 'payload', 'items']);
      var itemCount = items.size;

      return state.setIn(['data', dataSource, 'groups', group, 'filters', alias, 'meta', 'itemCount'], itemCount);
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: 'restoreDraft',
    value: function restoreDraft(dataSource, group, alias, id) {
      group = (0, _constants.groupName)(group);
      return {
        payload: id,
        meta: {
          alias: alias,
          group: group,
          id: id,
          dataSource: dataSource
        }
      };
    }
  }, {
    key: '_restoreDraftReducer',
    value: function _restoreDraftReducer(state, id, _ref17) {
      var group = _ref17.group,
          alias = _ref17.alias,
          dataSource = _ref17.dataSource;

      var dataSourceState = state.getIn(['data', dataSource]);
      if (!dataSourceState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      if (dataSourceState.dataSourceType !== _constants.DATA_SOURCE_TYPES.COLLECTION) {
        throw new Error('Cannot restore a draft.  Removing is only supported for collections.');
      }

      var groupState = dataSourceState.getIn(['groups', group]);
      if (!groupState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var filterState = groupState.getIn(['filters', alias]);
      if (!filterState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      return state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'payload'], function (payload) {
        return payload.mutateItem(id, restoreDraftItem());
      });
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: 'updateDraft',
    value: function updateDraft(dataSource, group, alias, id, changes) {
      group = (0, _constants.groupName)(group);
      return {
        payload: changes,
        meta: {
          dataSource: dataSource,
          group: group,
          alias: alias,
          id: id
        }
      };
    }
  }, {
    key: '_updateDraftReducer',
    value: function _updateDraftReducer(state, changes, _ref18) {
      var group = _ref18.group,
          alias = _ref18.alias,
          id = _ref18.id,
          dataSource = _ref18.dataSource;

      var dataSourceState = state.getIn(['data', dataSource]);
      if (!dataSourceState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var groupState = dataSourceState.getIn(['groups', group]);
      if (!groupState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var filterState = groupState.getIn(['filters', alias]);
      if (!filterState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var only = filterState.get('only');

      // Build reference proxy
      var reference = this._buildReferenceProxy({ state: state });

      return state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'payload'], function (payload) {
        return payload.mutateItem(id, updateDraftItem(groupState.model, changes, { only: only, reference: reference }));
      });
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: 'revertDraft',
    value: function revertDraft(dataSource, group, alias, id, keys) {
      if (keys === undefined) {
        throw new Error('Reverting a draft requires an array of keys or a REVERT_ constant');
      }
      if (id === undefined) {
        throw new Error('Reverting a draft requires a unique id or a REVERT_ constant');
      }
      group = (0, _constants.groupName)(group);
      return {
        payload: keys,
        meta: {
          dataSource: dataSource,
          group: group,
          alias: alias,
          id: id
        }
      };
    }
  }, {
    key: '_revertDraftReducer',
    value: function _revertDraftReducer(state, keys, _ref19) {
      var group = _ref19.group,
          alias = _ref19.alias,
          id = _ref19.id,
          dataSource = _ref19.dataSource;

      var dataSourceState = state.getIn(['data', dataSource]);
      if (!dataSourceState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var groupState = dataSourceState.getIn(['groups', group]);
      if (!groupState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var filterState = groupState.getIn(['filters', alias]);
      if (!filterState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      // Build reference proxy
      var reference = this._buildReferenceProxy({ state: state });

      return state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'payload'], function (payload) {
        return payload.mutateItem(id, revertDraftItem(groupState.model, keys, { reference: reference }));
      });
    }
  }, {
    key: 'saveDraft',
    value: function saveDraft(dataSource, group, alias, id, keys) {
      var _this25 = this;

      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      var withAdded = options.withAdded;


      group = (0, _constants.groupName)(group);
      return function (dispatch, getState) {
        // Locate the requested save payload
        var filterState = _this25.getState(getState()).getIn(['data', dataSource, 'groups', group, 'filters', alias]);
        if (filterState === undefined || filterState.payload === undefined) {
          // EARLY EXIT: No payload?  Nothing to write.
          return Promise.resolve();
        }

        var payload = filterState.payload;

        // Get all the changes in bulk.
        // ASSUME: saveItems(...) will return an empty list if a save is in progress on an item
        var changes = payload.saveItems(id, keys, { withAdded: withAdded });
        if (changes.isEmpty()) {
          // EARLY EXIT: No changes?  Nothing to write.
          return Promise.resolve();
        }

        var declaration = _this25.dataSources.get(dataSource);
        if (declaration['type'] === undefined) {
          throw new Error('Data source ' + dataSource + ' is missing the required type key.');
        }

        // Bind all the callbacks (these are item based, not collection based like the changes)
        var options = {
          onRequest: _this25._saveDraftOnRequest(dispatch, dataSource, group, alias),
          onReceive: _this25._saveDraftOnReceive(dispatch, getState, dataSource, group, alias),
          onReceiveUnauthenticated: _this25._saveDraftOnReceiveUnauthenticated(dispatch, dataSource, group, alias),
          onReceiveUnauthorized: _this25._saveDraftOnReceiveUnauthorized(dispatch, dataSource, group, alias),
          onError: _this25._saveDraftOnReceiveError(dispatch, dataSource, group, alias)
        };

        // Add auth if using
        if (_this25.auth) {
          options['getAuthenticationHeaders'] = _this25._getAuthenticationHeaders(getState);
        }
        // Add filter (query), if it's passed.
        if (alias !== _constants.DEFAULT_API_FILTER_NAME) {
          options['filter'] = filterState.query;
          options['sort'] = filterState.sort;
          options['only'] = filterState.only;
        }
        // Add group, if it's passed.
        if (group !== _constants.DEFAULT_API_GROUP_NAME) {
          options['group'] = group;
        }

        return _this25.dataWriter(dataSource, declaration, payload.constructor, changes, options);
      };
    }
  }, {
    key: '_saveDraftOnRequest',
    value: function _saveDraftOnRequest(dispatch, dataSource, group, alias) {
      var _this26 = this;

      return function (id, action, changes) {
        dispatch(_this26._requestSave(dataSource, group, alias, id, action, changes));
      };
    }
  }, {
    key: '_saveDraftOnReceive',
    value: function _saveDraftOnReceive(dispatch, getState, dataSource, group, alias) {
      var _this27 = this;

      return function (id, action, changes, data) {
        dispatch(_this27._receiveSave(dataSource, group, alias, id, action, changes, data));

        // A notification may have come in while the data was in flight.  Get the selector for this dataSource and filter
        // and then check if the data needs to be requested again.
        var needsRequest = _this27._needsRequest(dataSource, group, alias);
        if (needsRequest(getState())) {
          // Get the latest filter query out of the filter payload
          var payload = _this27.getState(getState()).getIn(['data', dataSource, 'groups', group, 'filters', alias, 'payload']);
          if (!!payload) {
            var request = _this27.request(dataSource, group, alias);
            dispatch(request());
          }
        }
      };
    }
  }, {
    key: '_saveDraftOnReceiveUnauthenticated',
    value: function _saveDraftOnReceiveUnauthenticated(dispatch, dataSource, group, alias) {
      var _this28 = this;

      return function (data) {
        _this28.requestLogout(data)(dispatch);
      };
    }
  }, {
    key: '_saveDraftOnReceiveUnauthorized',
    value: function _saveDraftOnReceiveUnauthorized(dispatch, dataSource, group, alias) {
      var _this29 = this;

      return function (id, action, changes, data) {
        dispatch(_this29._receiveSaveUnauthorized(dataSource, group, alias, id, action, changes, data));
      };
    }
  }, {
    key: '_saveDraftOnReceiveError',
    value: function _saveDraftOnReceiveError(dispatch, dataSource, group, alias) {
      var _this30 = this;

      return function (id, action, changes, error) {
        dispatch(_this30._receiveSaveError(dataSource, group, alias, id, action, changes, error));
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_requestSave',
    value: function _requestSave(dataSource, group, alias, id, action, changes) {
      group = (0, _constants.groupName)(group);
      return {
        payload: id,
        meta: {
          dataSource: dataSource,
          group: group,
          alias: alias,
          action: action,
          changes: changes
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_requestSaveReducer',
    value: function _requestSaveReducer(state, id, _ref20) {
      var group = _ref20.group,
          alias = _ref20.alias,
          dataSource = _ref20.dataSource;

      var dataSourceState = state.getIn(['data', dataSource]);
      if (!dataSourceState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var groupState = dataSourceState.getIn(['groups', group]);
      if (!groupState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var filterState = groupState.getIn(['filters', alias]);
      if (!filterState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      return state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'payload'], function (payload) {
        return payload.mutateItem(id, requestSaveItem());
      });
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveSave',
    value: function _receiveSave(dataSource, group, alias, id, action, changes, response) {
      return {
        payload: response,
        meta: {
          dataSource: dataSource,
          group: group,
          alias: alias,
          action: action,
          changes: changes,
          id: id
        }
      };
    }
  }, {
    key: '_receiveSaveCreate',
    value: function _receiveSaveCreate(state, response, dataSource, group, alias, id, changes) {
      var groupState = state.getIn(['data', dataSource, 'groups', group]);
      if (!groupState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      // SPECIAL CASE: Swap the internal ID for the newlly created ID.  Can only happen on Collections.
      var newID = response['id'];
      state = state.updateIn(['data', dataSource, 'groups', group, 'filters', alias], function (filterState) {
        return filterState.withMutations(function (filterMap) {
          // Swap the ID in the payload
          filterMap.set('payload', filterMap.get('payload').withMutations(function (map) {
            // Look up the item being created
            var items = map.get('items');
            var item = items.get(id);
            items = items.delete(id);

            // Swap the ID, and make sure the fixed ID stays the same (even if new data came in)
            item = item.merge({
              _interfaceID: id,
              _storeID: newID,
              _draftCreation: false

            });
            items = items.set(newID, item);

            // Put the new items back
            map.set('items', items);
          }));
          return filterMap;
        });
      });

      // Use the newID (now that it's been swapped in the state)
      id = newID;

      // Build reference proxy
      var reference = this._buildReferenceProxy({ state: state });

      return state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'payload'], function (payload) {
        return payload.mutateItem(id, receiveSaveItem(_constants.WRITE_STYLE.CREATE, groupState.model, id, changes, response, { reference: reference }));
      });
    }
  }, {
    key: '_receiveSaveUpdate',
    value: function _receiveSaveUpdate(state, response, dataSource, group, alias, id, changes) {
      var groupState = state.getIn(['data', dataSource, 'groups', group]);
      if (!groupState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var currentLastModified = void 0;
      var lastModified = response['last_modified'];
      if (!!lastModified) {
        lastModified = new Date(lastModified);
      }

      // Check if we need to flag the record as needing an update
      if (state.getIn(['data', dataSource, 'groups', group, 'filters', alias, 'meta', 'needsUpdate']) === false) {
        state = state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'meta'], function (metaState) {
          return metaState.withMutations(function (map) {
            currentLastModified = metaState.get('lastModified');
            if (!!currentLastModified) {
              currentLastModified = new Date(currentLastModified);
              if (currentLastModified < lastModified) {
                map.set('needsUpdate', true);
              }
            }
            return map;
          });
        });
      }

      // Build reference proxy
      var reference = this._buildReferenceProxy({ state: state });

      return state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'payload'], function (payload) {
        return payload.mutateItem(id, receiveSaveItem(_constants.WRITE_STYLE.UPDATE, groupState.model, id, changes, response, { reference: reference }));
      });
    }
  }, {
    key: '_receiveSaveDelete',
    value: function _receiveSaveDelete(state, response, dataSource, group, alias, id, changes) {
      var dataSourceState = state.getIn(['data', dataSource]);
      if (!dataSourceState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var groupState = dataSourceState.getIn(['groups', group]);
      if (!groupState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      return state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'payload'], function (payloadState) {
        return payloadState.withMutations(receiveSaveItemRemove(id));
      });
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveSaveReducer',
    value: function _receiveSaveReducer(state, response, _ref21) {
      var action = _ref21.action,
          changes = _ref21.changes,
          dataSource = _ref21.dataSource,
          group = _ref21.group,
          alias = _ref21.alias,
          id = _ref21.id;

      var dataSourceState = state.getIn(['data', dataSource]);
      if (!dataSourceState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var groupState = dataSourceState.getIn(['groups', group]);
      if (!groupState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var filterState = groupState.getIn(['filters', alias]);
      if (!filterState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      if (action === _constants.WRITE_STYLE.CREATE) {
        return this._receiveSaveCreate(state, response, dataSource, group, alias, id, changes);
      } else if (action === _constants.WRITE_STYLE.UPDATE) {
        return this._receiveSaveUpdate(state, response, dataSource, group, alias, id, changes);
      } else if (action === _constants.WRITE_STYLE.DELETE) {
        return this._receiveSaveDelete(state, response, dataSource, group, alias, id, changes);
      } else {
        throw new Error('Unknown write style when saving: "' + action + '"');
      }
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveSaveError',
    value: function _receiveSaveError(dataSource, group, alias, id, action, changes, error) {
      group = (0, _constants.groupName)(group);
      return {
        payload: error,
        meta: {
          dataSource: dataSource,
          group: group,
          alias: alias,
          action: action,
          changes: changes,
          id: id
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveSaveErrorReducer',
    value: function _receiveSaveErrorReducer(state, error, _ref22) {
      var dataSource = _ref22.dataSource,
          group = _ref22.group,
          alias = _ref22.alias,
          id = _ref22.id;

      var dataSourceState = state.getIn(['data', dataSource]);
      if (!dataSourceState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var groupState = dataSourceState.getIn(['groups', group, 'filters', alias]);
      if (!groupState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      return state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'payload'], function (payload) {
        return payload.mutateItem(id, receiveSaveItemError(error));
      });
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveSaveUnauthorized',
    value: function _receiveSaveUnauthorized(dataSource, group, alias, id, action, changes, data) {
      group = (0, _constants.groupName)(group);
      return {
        payload: data,
        meta: {
          dataSource: dataSource,
          group: group,
          alias: alias,
          action: action,
          changes: changes,
          id: id
        }
      };
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: '_receiveSaveUnauthorizedReducer',
    value: function _receiveSaveUnauthorizedReducer(state, error, _ref23) {
      var dataSource = _ref23.dataSource,
          group = _ref23.group,
          alias = _ref23.alias,
          id = _ref23.id;

      var dataSourceState = state.getIn(['data', dataSource]);
      if (!dataSourceState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var groupState = dataSourceState.getIn(['groups', group, 'filters', alias]);
      if (!groupState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      return state.updateIn(['data', dataSource, 'groups', group, 'filters', alias, 'payload'], function (payload) {
        return payload.mutateItem(id, receiveSaveItemError(error));
      } // TODO - should this be treated differently than other generic save errors?!
      );
    }

    //noinspection JSMethodCanBeStatic

  }, {
    key: 'addServerTemporary',
    value: function addServerTemporary(dataSource, group, alias, id, serverValues) {
      group = (0, _constants.groupName)(group);
      return {
        payload: { id: id, serverValues: serverValues },
        meta: {
          dataSource: dataSource,
          group: group,
          alias: alias
        }
      };
    }

    //noinspection JSUnusedGlobalSymbols

  }, {
    key: '_addServerTemporaryReducer',
    value: function _addServerTemporaryReducer(state, _ref24, _ref25) {
      var id = _ref24.id,
          serverValues = _ref24.serverValues;
      var group = _ref25.group,
          alias = _ref25.alias,
          dataSource = _ref25.dataSource;

      var dataSourceState = state.getIn(['data', dataSource]);
      if (!dataSourceState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      if (dataSourceState.dataSourceType !== _constants.DATA_SOURCE_TYPES.COLLECTION) {
        throw new Error('Cannot add server temporary values.  Adding is only supported for collections.');
      }

      var groupState = dataSourceState.getIn(['groups', group]);
      if (!groupState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var filterState = groupState.getIn(['filters', alias]);
      if (!filterState) {
        // State no longer exists.  May have been evicted.
        return state;
      }

      var only = filterState.get('only');

      if (!id) {
        // No falsey value can be used for the id (0, "", false etc...)
        throw new Error('Cannot add a server temporary without a unique ID');
      }

      var idPath = ['data', dataSource, 'groups', group, 'filters', alias, 'payload', 'items', id];
      var idState = state.getIn(idPath);
      if (!!idState) {
        throw new Error('Cannot overwrite existing data for ID "' + id + '" with a server temporary.');
      }

      // Build reference proxy
      var reference = this._buildReferenceProxy({ state: state });

      // Add the new draft item
      return state.updateIn(idPath, function (payloadState) {
        return createServerItem(groupState.model, id, serverValues, { only: only, temporary: true, reference: reference });
      });
    }
  }, {
    key: 'read',
    value: function read(state, dataSource, group, alias) {
      group = (0, _constants.groupName)(group);
      return this._readSelector(dataSource, group, alias)(state);
    }
  }, {
    key: '_readSelector',
    value: function _readSelector(dataSource, group, alias) {
      return (0, _reselect.createSelector)(this.getState, this._readInternalSelector(dataSource, group, alias));
    }
  }, {
    key: 'readInternal',
    value: function readInternal(state, dataSource, group, alias) {
      group = (0, _constants.groupName)(group);
      return this._readInternalSelector(dataSource, group, alias)(state);
    }
  }, {
    key: '_readInternalSelector',
    value: function _readInternalSelector(dataSource, group, alias) {
      var _this31 = this;

      return function (state) {
        if (alias === _this31.disabledFilterSentinel) {
          // EARLY EXIT: Filter is disabled
          return undefined;
        }

        var dataSourceState = state.getIn(['data', dataSource]);
        if (dataSourceState === undefined) {
          // EARLY EXIT: Filter is disabled
          return undefined;
        }

        return dataSourceState.getIn(['groups', group, 'filters', alias, 'payload']);
      };
    }
  }, {
    key: 'meta',
    value: function meta(state, dataSource, group, alias) {
      group = (0, _constants.groupName)(group);
      return this._metaSelector(dataSource, group, alias)(state);
    }
  }, {
    key: '_metaSelector',
    value: function _metaSelector(dataSource, group, alias) {
      return (0, _reselect.createSelector)(this.getState, this._metaInternalSelector(dataSource, group, alias));
    }
  }, {
    key: 'metaInternal',
    value: function metaInternal(state, dataSource, group, alias) {
      group = (0, _constants.groupName)(group);
      return this._metaInternalSelector(dataSource, group, alias)(state);
    }
  }, {
    key: '_metaInternalSelector',
    value: function _metaInternalSelector(dataSource, group, alias) {
      var _this32 = this;

      return function (state) {
        if (alias === _this32.disabledFilterSentinel) {
          // EARLY EXIT: Disabled.  Just return an unloaded meta.
          return _models.apiMetaUnloaded;
        }

        var meta = state.getIn(['data', dataSource, 'groups', group, 'filters', alias, 'meta']);
        if (!meta) {
          // EARLY EXIT: Doesn't exist.  Just return an unloaded meta.
          return _models.apiMetaUnloaded;
        }

        return meta;
      };
    }
  }, {
    key: 'authentication',
    value: function authentication(state) {
      return this._authenticationSelector()(state);
    }
  }, {
    key: '_authenticationSelector',
    value: function _authenticationSelector() {
      return (0, _reselect.createSelector)(this.getState, this._authenticationInternalSelector());
    }
  }, {
    key: 'authenticationInternal',
    value: function authenticationInternal(state) {
      return this._authenticationInternalSelector()(state);
    }
  }, {
    key: '_authenticationInternalSelector',
    value: function _authenticationInternalSelector() {
      return function (state) {
        return state.getIn(['authentication']);
      };
    }
  }]);

  return Api;
}(_amsLoaderUtils.ReduxModule), (_applyDecoratedDescriptor(_class.prototype, '_loginSync', [_dec], Object.getOwnPropertyDescriptor(_class.prototype, '_loginSync'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_loginSyncReducer', [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, '_loginSyncReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_loginRequest', [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, '_loginRequest'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_loginRequestReducer', [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, '_loginRequestReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_loginSuccess', [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, '_loginSuccess'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_loginSuccessReducer', [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, '_loginSuccessReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_loginError', [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, '_loginError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_loginErrorReducer', [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, '_loginErrorReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_logoutSync', [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, '_logoutSync'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_logoutSyncReducer', [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, '_logoutSyncReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_logoutRequest', [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, '_logoutRequest'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_logoutRequestReducer', [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, '_logoutRequestReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_logoutSuccess', [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, '_logoutSuccess'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_logoutSuccessReducer', [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, '_logoutSuccessReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_logoutError', [_dec15], Object.getOwnPropertyDescriptor(_class.prototype, '_logoutError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_logoutErrorReducer', [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, '_logoutErrorReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'checkLogin', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'checkLogin'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'requestLogin', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'requestLogin'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'requestLogout', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'requestLogout'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'subscribe', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, 'subscribe'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_subscribeInner', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_subscribeInner'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_subscribe', [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, '_subscribe'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_subscribeReducer', [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, '_subscribeReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'unsubscribe', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, 'unsubscribe'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_unsubscribe', [_dec19], Object.getOwnPropertyDescriptor(_class.prototype, '_unsubscribe'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_unsubscribeReducer', [_dec20], Object.getOwnPropertyDescriptor(_class.prototype, '_unsubscribeReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_cleanupState', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_cleanupState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'cleanup', [_dec21], Object.getOwnPropertyDescriptor(_class.prototype, 'cleanup'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_cleanupReducer', [_dec22], Object.getOwnPropertyDescriptor(_class.prototype, '_cleanupReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_serverDataAvailable', [_dec23], Object.getOwnPropertyDescriptor(_class.prototype, '_serverDataAvailable'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_serverDataAvailableReducer', [_dec24], Object.getOwnPropertyDescriptor(_class.prototype, '_serverDataAvailableReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'maybeRequest', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, 'maybeRequest'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestModel', [_dec25], Object.getOwnPropertyDescriptor(_class.prototype, '_requestModel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestModelReducer', [_dec26], Object.getOwnPropertyDescriptor(_class.prototype, '_requestModelReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveModel', [_dec27], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveModel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveModelReducer', [_dec28], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveModelReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveModelError', [_dec29], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveModelError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveModelErrorReducer', [_dec30], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveModelErrorReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_request', [_dec31], Object.getOwnPropertyDescriptor(_class.prototype, '_request'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestReducer', [_dec32], Object.getOwnPropertyDescriptor(_class.prototype, '_requestReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receive', [_dec33], Object.getOwnPropertyDescriptor(_class.prototype, '_receive'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveReducer', [_dec34], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_verifyRelated', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_verifyRelated'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveError', [_dec35], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveErrorReducer', [_dec36], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveErrorReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveUnauthorized', [_dec37], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveUnauthorized'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveUnauthorizedReducer', [_dec38], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveUnauthorizedReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveModelUnauthorized', [_dec39], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveModelUnauthorized'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveModelUnauthorizedReducer', [_dec40], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveModelUnauthorizedReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'requestModel', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, 'requestModel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'request', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, 'request'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestModelOnRequest', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_requestModelOnRequest'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestModelOnReceive', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_requestModelOnReceive'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestModelOnReceiveUnauthenticated', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_requestModelOnReceiveUnauthenticated'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestModelOnReceiveUnauthorized', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_requestModelOnReceiveUnauthorized'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestModelOnReceiveError', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_requestModelOnReceiveError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_getRequestFilterMetaStateSelector', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, '_getRequestFilterMetaStateSelector'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_loadData', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_loadData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestOnRequest', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_requestOnRequest'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestOnReceive', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_requestOnReceive'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestOnReceiveUnchanged', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_requestOnReceiveUnchanged'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestOnReceiveUnauthenticated', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_requestOnReceiveUnauthenticated'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestOnReceiveUnauthorized', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_requestOnReceiveUnauthorized'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_needsRequest', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, '_needsRequest'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestOnReceiveError', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_requestOnReceiveError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addDraft', [_dec41], Object.getOwnPropertyDescriptor(_class.prototype, 'addDraft'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_addDraftReducer', [_dec42], Object.getOwnPropertyDescriptor(_class.prototype, '_addDraftReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeDraft', [_dec43], Object.getOwnPropertyDescriptor(_class.prototype, 'removeDraft'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_removeDraftReducer', [_dec44], Object.getOwnPropertyDescriptor(_class.prototype, '_removeDraftReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'restoreDraft', [_dec45], Object.getOwnPropertyDescriptor(_class.prototype, 'restoreDraft'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_restoreDraftReducer', [_dec46], Object.getOwnPropertyDescriptor(_class.prototype, '_restoreDraftReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateDraft', [_dec47], Object.getOwnPropertyDescriptor(_class.prototype, 'updateDraft'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_updateDraftReducer', [_dec48], Object.getOwnPropertyDescriptor(_class.prototype, '_updateDraftReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'revertDraft', [_dec49], Object.getOwnPropertyDescriptor(_class.prototype, 'revertDraft'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_revertDraftReducer', [_dec50], Object.getOwnPropertyDescriptor(_class.prototype, '_revertDraftReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_saveDraftOnRequest', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_saveDraftOnRequest'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_saveDraftOnReceive', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_saveDraftOnReceive'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_saveDraftOnReceiveUnauthenticated', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_saveDraftOnReceiveUnauthenticated'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_saveDraftOnReceiveUnauthorized', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_saveDraftOnReceiveUnauthorized'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_saveDraftOnReceiveError', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, '_saveDraftOnReceiveError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestSave', [_dec51], Object.getOwnPropertyDescriptor(_class.prototype, '_requestSave'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_requestSaveReducer', [_dec52], Object.getOwnPropertyDescriptor(_class.prototype, '_requestSaveReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveSave', [_dec53], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveSave'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveSaveReducer', [_dec54], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveSaveReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveSaveError', [_dec55], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveSaveError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveSaveErrorReducer', [_dec56], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveSaveErrorReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveSaveUnauthorized', [_dec57], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveSaveUnauthorized'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_receiveSaveUnauthorizedReducer', [_dec58], Object.getOwnPropertyDescriptor(_class.prototype, '_receiveSaveUnauthorizedReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addServerTemporary', [_dec59], Object.getOwnPropertyDescriptor(_class.prototype, 'addServerTemporary'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_addServerTemporaryReducer', [_dec60], Object.getOwnPropertyDescriptor(_class.prototype, '_addServerTemporaryReducer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'read', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'read'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_readSelector', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, '_readSelector'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'readInternal', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'readInternal'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_readInternalSelector', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, '_readInternalSelector'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'meta', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'meta'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_metaSelector', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, '_metaSelector'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'metaInternal', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'metaInternal'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_metaInternalSelector', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, '_metaInternalSelector'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'authentication', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'authentication'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_authenticationSelector', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, '_authenticationSelector'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'authenticationInternal', [_amsLoaderUtils.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'authenticationInternal'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_authenticationInternalSelector', [_amsLoaderUtils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, '_authenticationInternalSelector'), _class.prototype)), _class));